import React,{Component} from 'react';
import cancel from "../../../images/cancel.png";
import Skeleton from '@material-ui/lab/Skeleton';
import AuthHelper from "../../../libraries/auth-helper";
import TextField from '@material-ui/core/TextField';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import user from '../../../images/default.png';
import {Link, withRouter} from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import SimpleReactValidator from 'simple-react-validator';
import Api from '../../../libraries/api';
import StatusProject from '../../../images/status-project.png';
import StatusFinance from '../../../images/status-finance.png';
import editImage from '../../../images/edit.png';
import StatusOS from '../../../images/status-os.png';
import Button from '@material-ui/core/Button';
import SendIcon from '@material-ui/icons/Send';
import NumberFormat from 'react-number-format';
import ErrorHandling from '../../../libraries/error-handling';
import {toast, ToastContainer} from 'react-toastify';
import {history} from '../../../shared/configure-store';
import _ from 'lodash';
import MomentUtils from '@date-io/moment';
import moment from 'moment/moment';
import {bindActionCreators} from 'redux';
import {RootActions} from '../../../shared/root-action';
import {connect} from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { 
    PROJECT_EXPENSES_DEFAULT_LIST, 
    PROJECT_TYPE_IDS, 
    MULTIPLE_SUMMARY_OF_COST_DEFAULT_LIST,
} from '../../../constants/global';
import CommonHelper from "../../../libraries/common-helper";

require('dotenv').config();
const validator = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});
const validatorProject = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});
const validatorSurvey = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});
const validatorComment = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});
const validatorCommentClient = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});
const validatorProjectSummary = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});
const validatorSummaryOfCost = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});
const validatorEx = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});
const validatorRateExpenses = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});

const SURVEY_EXPENSE_DESCRIPTIONS = PROJECT_EXPENSES_DEFAULT_LIST.survey;

class ProjectsDetail extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: true,
            loadingCommentList: false,
            loadingCommentListClient: false,
            loadingButton: false,
            loadingProject: false,
            loadingCase: false,
            loadingSurvey: false,
            loadingComment: false,
            loadingProjectSummary: false,
            loadingSummaryOfCost: false,
            loadingSave: false,
            loadingCaseStatusMultiple: false,
            loadingCaseSurveyStatusMultiple: false,
            loadingApprovalStatusMultiple: false,
            loadingSummaryOfCostMultiple: false,
            errors: {},

            permissions: [],

            showDialog: false,
            showDialogDelete: false,
            showDialogRevert: false,

            editStatus: false,
            editStatusCase: false,
            editSurvey: false,
            queryParam: false,

            underWriters: [],
            broker: [],
            adjuster: [],
            shipowner: [],
            clients: [],
            instructor: '',

            survey_status: [],
            report_status: [],
            case_status: [],
            approval_status: [],
            project_status: '',
            finance_status: '',
            project_status_id: '',
            project_status_name: '',
            date_status: null,
            comment: '',
            case_status_id: '',
            case_status_name: '',
            client_comment: '',

            survey_status_id: '',
            survey_status_name: '',
            survey_comment: '',
            survey_remarks: '',
            date_survey_status: '',

            case_number: '',
            project_number: '',
            ext_project_number: '',
            case_type: '',
            type: '',
            type_id: '',
            detail_type: '',
            vessel_name: '',
            vesselType: null,
            vesselTypeData: '',
            vessel_grt: '',
            vessel_yob: '',
            engine_particular_hp: '',
            underwriters: [],
            casualty: '',
            casualtyType: null,
            place_of_accident: '',
            instruction_date: null,
            date_of_accident: null,
            instruction_by: '',
            pic_case: '',
            currency: '',
            estimation_cost: '',

            project_summary: '',
            place_of_repair: '',
            summary_of_cost: '',
            salvage_check: 0,
            salvage_remarks: '',
            repair_check: 0,
            repair_remarks: '',
            replace_check: 0,
            replace_remarks: '',
            incoming_approval_check: 0,
            allegation_check: 0,
            allegation_remarks: '',
            claim_document_check: 0,
            claim_document_remarks: '',
            warranty_check: 0,
            warranty_remarks: '',

            surveyor: [],
            admins: [],
            finalReviewer: [],
            under: '',
            soft_copy_data: 0,
            hard_copy_report: 0,
            hard_copy_invoice: 0,

            user_comment: '',
            user_id_current: '',

            comment_list: [],
            comment_list_client: [],

            case_status_multiple: [],
            case_survey_status_multiple: [],
            approval_status_multiple: [],
            summary_of_cost_multiple: [],
            lifecycle_case_survey_status_master: [],
            lifecycle_approval_status_master: [],
            summary_of_cost_master: [],
            multiple_summary_of_cost_options_list: MULTIPLE_SUMMARY_OF_COST_DEFAULT_LIST,

            uncategorized_expenses: [],
            survey_expenses: [],
            office_expenses: [],
            fx_rate: 0,
            total_survey_expenses: 0,
            total_office_expenses: 0,
            total_expenses: 0,
            show_fx_rate: false,

            total_in: 0,
            total_out: 0,
            saldo: 0,
            survey_hours: 0,
            survey_days: 0,

            top_project_status: '',
            top_finance_status: '',
            top_os: 0,

            photo: null,
            image: null,
            typeDelete: '',


        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEditStatus = this.handleEditStatus.bind(this);
        this.handleEditStatusCase = this.handleEditStatusCase.bind(this);
        this.handleEditStatusSurvey = this.handleEditStatusSurvey.bind(this);
        this.handleCancelEditStatus = this.handleCancelEditStatus.bind(this);
        this.handleCancelEditStatusSurvey = this.handleCancelEditStatusSurvey.bind(this);
        this.handleCancelEditStatusCase = this.handleCancelEditStatusCase.bind(this);
        this.handleSubmitStatus = this.handleSubmitStatus.bind(this);
        // this.handleSubmitStatusCase = this.handleSubmitStatusCase.bind(this);
        this.handleSubmitStatusSurvey = this.handleSubmitStatusSurvey.bind(this);
        this.handleComment = this.handleComment.bind(this);
        this.handleCommentClient = this.handleCommentClient.bind(this);
        this.handleNewExpense = this.handleNewExpense.bind(this);
        this.handleNewAdvance = this.handleNewAdvance.bind(this);
        this.handleSaveExpenses = this.handleSaveExpenses.bind(this);
        this.handleChangeExpenseSurvey = this.handleChangeExpenseSurvey.bind(this);
        this.handleChangeExpenseOffice = this.handleChangeExpenseOffice.bind(this);
        this.handleDeleteExpenseSurvey = this.handleDeleteExpenseSurvey.bind(this);
        this.handleDeleteExpenseOffice = this.handleDeleteExpenseOffice.bind(this);
        this.handleChangeExpenseUncategorized = this.handleChangeExpenseUncategorized.bind(this);
        this.handleDeleteExpenseUncategorized = this.handleDeleteExpenseUncategorized.bind(this);
        this.handleOpenDeleteComment = this.handleOpenDeleteComment.bind(this);

    }

    componentDidMount() {
        document.title = 'Abadi - Detail Project';

        this.setState({
            loading: true,
            loadingCommentList: true,
            permissions: AuthHelper.getProfile().permissions,
        });

        this.__fetch();

        Api.get('/clients?limit=0').then(resp => {
            if (resp.data) this.setState({ clients: resp.data });
        });

        Api.get('/project/status?limit=0').then(resp => {
            if (resp.data) {
                let report = [];
                let approval = [];

                if(resp.data.length > 0) {
                    _.forEach(resp.data, function(v,i) {
                        if (v.type === 'Report' && v.project_status !== 'Deleted') {
                            report.push(v);
                        } else if (v.type === 'Approval' && v.project_status !== 'Deleted') {
                            approval.push(v);
                        }
                    });
                }

                // this.setState({ report_status: report, approval_status: approval });

                const mapProjectReportStatusOrder = CommonHelper.mapProjectReportStatusOrder(report);
                const mapProjectApprovalStatusOrder = CommonHelper.mapProjectApprovalStatusOrder(approval);

                this.setState({ report_status: mapProjectReportStatusOrder, approval_status: mapProjectApprovalStatusOrder });
            }
        });

        Api.get('/survey/status?limit=0').then(resp => {
            if (resp.data) this.setState({ survey_status: resp.data });
        });

        this.__fetchMultipleCaseStatusDropdown();
        this.__fetchMultipleCaseSurveyStatusDropdown();
        this.__fetchLifecycleApprovalStatusMaster();
        this.__fetchSummaryOfCostMaster();

        // this.__fetchExpenses();
        // this.__fetchComment();
    }

    // =============================================================================
    // Data loading: project detail, comments, lifecycle pivot rows
    // =============================================================================
    __fetchComment = () => {
        const id = this.props.match.params.id;
        Api.get('/comments?search=projects_id:'+id+'&limit=0').then(resp => {
            if (resp.data) {
                this.setState({
                    comment_list: resp.data,
                    loadingCommentList: false
                });

                if (this.props.profile_state) {
                    this.setState({ user_id_current: this.props.profile_state.id });
                }
            }
        }).catch(err => {
            this.setState({ loadingCommentList: false });
        });

        Api.get('/client-comments?search=projects_id:'+id+'&limit=0').then(resp => {
            if (resp.data) {
                this.setState({
                    comment_list_client: resp.data,
                    loadingCommentListClient: false
                });

                if (this.props.profile_state) {
                    this.setState({
                        user_id_current: this.props.profile_state.id,
                    })
                }
            }
        }).catch(err => {
            console.log(err);
            this.setState({ loadingCommentList: false });
        });
    };

    __fetch = () => {
        const id = this.props.match.params.id;
        const include = 'comments,clientComments,expenses,repairs,files';

        Promise.all([
            Api.get(`/projects/${id}?include=${include}`),
            Api.get(`/projects/${id}/lifecycle/case-status-items`).catch(() => null),
            Api.get(`/projects/${id}/lifecycle/case-survey-status-items`).catch(() => null),
            Api.get(`/projects/${id}/lifecycle/approval-status-items`).catch(() => null),
            Api.get(`/projects/${id}/lifecycle/summary-of-cost-items`).catch(() => null),
        ]).then(([resp, caseStatusItemsResp, caseSurveyStatusItemsResp, approvalItemsResp, summaryItemsResp]) => {
            if (resp.data) {
                let data = resp.data;

                let case_status_multiple = [];
                const mapCasePivotRow = (row) => ({
                    id: row.id,
                    cases_status_id: row.cases_status_id ?? row.casesStatusId ?? '',
                    notes: row.notes != null ? String(row.notes) : '',
                });
                if (caseStatusItemsResp && caseStatusItemsResp.data !== undefined) {
                    const raw = caseStatusItemsResp.data;
                    const list = Array.isArray(raw) ? raw : (raw?.data || []);
                    case_status_multiple = list.map(mapCasePivotRow);
                }
                if (case_status_multiple.length === 0) {
                    const design = data.casesStatusDesign || data.cases_status_design;
                    if (Array.isArray(design)) {
                        case_status_multiple = design.map((row) => ({
                            id: row.id,
                            cases_status_id: row.casesStatusId ?? row.cases_status_id ?? '',
                            notes: row.notes != null ? String(row.notes) : '',
                        }));
                    }
                }

                let case_survey_status_multiple = [];
                const mapCaseSurveyPivotRow = (row) => ({
                    id: row.id,
                    case_survey_status_id: row.case_survey_status_id ?? row.caseSurveyStatusId ?? row.survey_status_id ?? row.surveyStatusId ?? '',
                    notes: row.notes != null ? String(row.notes) : '',
                });
                if (caseSurveyStatusItemsResp && caseSurveyStatusItemsResp.data !== undefined) {
                    const raw = caseSurveyStatusItemsResp.data;
                    const list = Array.isArray(raw) ? raw : (raw?.data || []);
                    case_survey_status_multiple = list.map(mapCaseSurveyPivotRow);
                }
                if (case_survey_status_multiple.length === 0) {
                    const design = data.caseSurveyStatusDesign || data.case_survey_status_design || data.surveyStatusDesign || data.survey_status_design;
                    if (Array.isArray(design)) {
                        case_survey_status_multiple = design.map((row) => ({
                            id: row.id,
                            case_survey_status_id: row.caseSurveyStatusId ?? row.case_survey_status_id ?? row.surveyStatusId ?? row.survey_status_id ?? '',
                            notes: row.notes != null ? String(row.notes) : '',
                        }));
                    }
                }

                let approval_status_multiple = [];
                const mapApprovalPivotRow = (row) => ({
                    id: row.id,
                    approval_status_id: row.approval_status_id ?? row.approvalStatusId ?? '',
                    remarks: row.remarks != null ? String(row.remarks) : '',
                });
                if (approvalItemsResp && approvalItemsResp.data !== undefined) {
                    const raw = approvalItemsResp.data;
                    const list = Array.isArray(raw) ? raw : (raw?.data || []);
                    approval_status_multiple = list.map(mapApprovalPivotRow);
                }
                if (approval_status_multiple.length === 0) {
                    const design = data.approvalStatusDesign || data.approval_status_design;
                    if (Array.isArray(design)) {
                        approval_status_multiple = design.map((row) => ({
                            id: row.id,
                            approval_status_id: row.approvalStatusId ?? row.approval_status_id ?? '',
                            remarks: row.remarks != null ? String(row.remarks) : '',
                        }));
                    }
                }

                let summary_of_cost_multiple = [];
                const formatSocNum = (v) => {
                    if (v === null || v === undefined || v === '') return '';
                    const n = typeof v === 'number' ? v : parseFloat(String(v).replace(/,/g, ''));
                    return Number.isFinite(n) ? String(n) : '';
                };
                const mapSummaryPivotRow = (row) => ({
                    id: row.id,
                    summary_of_cost_id: row.summary_of_cost_id ?? row.summaryOfCostId ?? '',
                    report_estimation: formatSocNum(row.report_estimation ?? row.reportEstimation),
                    claim_from_owner_in_approval: formatSocNum(row.claim_from_owner_in_approval ?? row.claimFromOwnerInApproval),
                    remarks: row.remarks != null ? String(row.remarks) : '',
                });
                if (summaryItemsResp && summaryItemsResp.data !== undefined) {
                    const raw = summaryItemsResp.data;
                    const list = Array.isArray(raw) ? raw : (raw?.data || []);
                    summary_of_cost_multiple = list.map(mapSummaryPivotRow);
                }
                if (summary_of_cost_multiple.length === 0) {
                    const design = data.summaryOfCostDesign || data.summary_of_cost_design;
                    if (Array.isArray(design)) {
                        summary_of_cost_multiple = design.map((row) => ({
                            id: row.id,
                            summary_of_cost_id: row.summaryOfCostId ?? row.summary_of_cost_id ?? '',
                            report_estimation: formatSocNum(row.reportEstimation ?? row.report_estimation),
                            claim_from_owner_in_approval: formatSocNum(row.claimFromOwnerInApproval ?? row.claim_from_owner_in_approval),
                            remarks: row.remarks != null ? String(row.remarks) : '',
                        }));
                    }
                }
                const comments = Array.isArray(data.comments) ? data.comments : (data.comments?.data || []);
                const clientComments = Array.isArray(data.clientComments) ? data.clientComments : (data.clientComments?.data || []);
                const expensesRaw = Array.isArray(data.expenses) ? data.expenses : (data.expenses?.data || []);

                const survey_expenses = expensesRaw.filter(e => e?.typeExpenses === 'survey');
                const office_expenses = expensesRaw.filter(e => e?.typeExpenses === 'office');
                const uncategorized_expenses = expensesRaw.filter(e => (e?.typeExpenses === '' || e?.typeExpenses === null));
                const expenseMeta = data.expenses && typeof data.expenses === 'object' && data.expenses.meta ? data.expenses.meta.custom : null;

                this.setState({
                    loading: false,
                    loadingCommentList: false,
                    loadingCommentListClient: false,
                    comment_list: comments,
                    comment_list_client: clientComments,
                    survey_expenses,
                    office_expenses,
                    uncategorized_expenses,
                    ...(expenseMeta ? {
                        total_in: expenseMeta.totalIn ?? 0,
                        total_out: expenseMeta.totalOut ?? 0,
                        saldo: expenseMeta.saldo ?? 0,
                    } : {}),
                    case_number: data.caseNumber,
                    project_number: data.projectNumber,
                    ext_project_number: data.extProjectNumber,
                    case_type: data.caseType,
                    type: data.type ? data.type.name : '',
                    type_id: data.type ? data.type.id : '',
                    detail_type: data.detailType ? data.detailType.name :'',
                    detail_type_id: data.detailType ? data.detailType.id :'',
                    vessel_name: data.vesselName,
                    vesselType: data?.vesselType,
                    vesselTypeData: data?.vesselTypeData,
                    vessel_grt: data.vesselGrt,
                    vessel_yob: data.vesselYob,
                    engine_particular_hp: data?.engineParticularHp,
                    broker: data.broker ? data.broker.name : '',
                    adjuster: data.adjuster ? data.adjuster.name : '',
                    shipowner: data.shipowner ? data.shipowner.name : '',
                    instructor: data?.instructor?.name || '',
                    underwriters: data.underWriters,
                    casualty: data.casualty,
                    casualtyType: data.casualtyType,
                    place_of_accident: data.placeOfAccident,
                    instruction_date: data.instructionDate || null,
                    approval_category: data?.approvalCategory,
                    date_of_accident: data.dateOfAccident || null,
                    instruction_by: data.instructionBy,
                    pic_case: data.picCase,
                    hard_copy_invoice: data.hardCopyInvoice,
                    hard_copy_report: data.hardCopyReport,
                    soft_copy_data: data.softCopyData,
                    estimation_cost: data.estimationCost && data?.estimationCost !== "null" ? data.estimationCost : '',
                    total_account_submitted: data.total_account_submitted,
                    total_account_approved: data.total_account_approved,
                    total_account_approved_for_cost: data.total_account_approved_for_cost,
                    total_account_approved_with_comment: data.total_account_approved_with_comment,
                    total_account_not_approved: data.total_account_not_approved,
                    residual_scrap_value: data.residual_scrap_value,
                    repairs: data.repairs,
                    files: data.files,

                    project_summary: data.projectSummary,
                    place_of_repair: data.place_of_repair,
                    summary_of_cost: data.summary_of_cost,
                    salvage_check: data?.salvageCheck,
                    salvage_remarks: data?.salvageRemarks,
                    repair_check: data?.repairCheck,
                    repair_remarks: data?.repairRemarks,
                    replace_check: data?.replaceCheck,
                    replace_remarks: data?.replaceRemarks,
                    incoming_approval_check: data?.incomingApprovalCheck,
                    allegation_check: data?.allegation_check,
                    allegation_remarks: data?.allegation_remarks,
                    claim_document_check: data?.claim_document_check,
                    claim_document_remarks: data?.claim_document_remarks,
                    warranty_check: data?.warranty_check,
                    warranty_remarks: data?.warranty_remarks,

                    approval_status_multiple,
                    summary_of_cost_multiple,
                    case_status_multiple,
                    case_survey_status_multiple,

                    surveyor: data.surveyor,
                    admins: data.admins,
                    finalReviewer: data.finalReviewer,

                    project_status: data.projectStatus,
                    project_survey_status: data.surveyStatus,
                    finance_status: data.financeStatus,

                    project_status_id: data.projectStatus ? data.projectStatus.id : '',
                    project_status_name: data.projectStatus ? data.projectStatus.name : '',
                    case_status_id: data.caseStatus ? data.caseStatus.id : '',
                    case_status_name: data.caseStatus ? data.caseStatus.name : '',
                    date_status: data.dateStatus,
                    comment: data.comment ? data.projectStatusComment : '',

                    survey_status_name: data.surveyStatus ? data.surveyStatus.name : '',
                    survey_status_id: data.surveyStatus ? data.surveyStatus.id : '',
                    survey_comment: data.surveyComment ? data.surveyComment : '',
                    survey_remarks: data.surveyRemarks ? data.surveyRemarks : '',
                    date_survey_status: data.dateSurveyStatus || null,

                    top_project_status: data.projectStatusBar ? data.projectStatusBar.project_status : '',
                    top_finance_status: data.financeStatus ? data.financeStatus : '',
                    top_os: data.totalBalance ? data.totalBalance : 0,
                    survey_hours: data.totalSurveyHour ? data.totalSurveyHour : 0,
                    survey_days: data.survey_days ? data.survey_days : 0,

                    currency: data.currency,
                    show_fx_rate: data?.currency !== 'IDR',
                    fx_rate: data?.fxRate,
                    total_survey_expenses: data?.totalSurveyExpenses,
                    total_office_expenses: data?.totalOfficeExpenses,
                    total_expenses: data?.totalExpenses,
                }, () => {
                    // this.__fetchCaseStatus(data.type.id || null);
                    const defaultDescriptions = SURVEY_EXPENSE_DESCRIPTIONS;
                    const currentDescriptions = (this.state.survey_expenses || []).map(e => (e.description || '').trim().toLowerCase());
                    const missing = defaultDescriptions.some(desc => !currentDescriptions.includes(desc.toLowerCase()));
                    if (missing) {
                        this.handleAutofillDefaultExpenses();
                    }

                    this.maybeAutofillSummaryOfCostDefaults();
                });
            }
        }).catch(err => {
            console.log(err);
            this.setState({ loading: false });
        });
    };
    // =============================================================================
    // Lifecycle: master dropdown lists (GET /lifecycle/*-master)
    // =============================================================================
    __fetchMultipleCaseStatusDropdown = () => {
        Api.get('/lifecycle/cases-status-master').then(resp => {
            const raw = resp.data;
            const list = Array.isArray(raw) ? raw : (raw?.data || []);
            const case_status = _.sortBy(list, [(o) => (o.sort_order ?? 0), (o) => (o.name || '').toLowerCase()]);
            this.setState({ case_status });
        }).catch(err => {
            this.setState({ case_status: [] });
        });
    };

    __fetchMultipleCaseSurveyStatusDropdown = () => {
        Api.get('/lifecycle/case-survey-status-master').then(resp => {
            const raw = resp.data;
            const list = Array.isArray(raw) ? raw : (raw?.data || []);
            const lifecycle_case_survey_status_master = _.sortBy(list, [(o) => (o.sort_order ?? 0), (o) => (o.name || '').toLowerCase()]);
            this.setState({ lifecycle_case_survey_status_master });
        }).catch(err => {
            this.setState({ lifecycle_case_survey_status_master: [] });
        });
    };

    __fetchLifecycleApprovalStatusMaster = () => {
        Api.get('/lifecycle/approval-status-master').then(resp => {
            const raw = resp.data;
            const list = Array.isArray(raw) ? raw : (raw?.data || []);
            const lifecycle_approval_status_master = _.sortBy(list, [(o) => (o.sort_order ?? 0), (o) => (o.name || '').toLowerCase()]);
            this.setState({ lifecycle_approval_status_master });
        }).catch(err => {
            this.setState({ lifecycle_approval_status_master: [] });
        });
    };

    __fetchSummaryOfCostMaster = () => {
        Api.get('/lifecycle/summary-of-cost-master').then(resp => {
            const raw = resp.data;
            const list = Array.isArray(raw) ? raw : (raw?.data || []);
            const summary_of_cost_master = _.sortBy(list, [(o) => (o.sort_order ?? 0), (o) => (o.name || '').toLowerCase()]);
            this.setState({ summary_of_cost_master }, () => this.maybeAutofillSummaryOfCostDefaults());
        }).catch(err => {
            this.setState({ summary_of_cost_master: [] });
        });
    };

    // =============================================================================
    // UI helpers, filters, navigation
    // =============================================================================
    showMessage = (status, message) => {
        if (status) toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
        else toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
    };
    filterName = (id) => {
        let all = this.state.clients.filter((item) => item.id === id);
        if(all.length > 0)
            return all[0].name;
    };

    filterPermission = (name) => {
        let all = this.state.permissions.filter((item) => item === name);
        if (all.length > 0)  return true;
    };
    filterStatus = (name) => {
        let text = '';
        switch(name) {
            case 'Follow Up':
                text = 'yellow';
                break;
            case 'On Progress':
                text = 'blue';
                break;
            case 'Finish':
                text = 'purple';
                break;
            case 'Completed':
                text = 'green';
                break;
            case 'Cancel':
                text = 'red';
                break;
            case 'Pending':
                text = 'yellow';
                break;
            case 'Partial Payment':
                text = 'green';
                break;
            case 'Complete Payment':
                text = 'blue';
                break;
            default:
                text = '';
        }

        return text;
    };
    handleGo  = (link) => {
        history.push(link);
    };

    // =============================================================================
    // Generic field handlers
    // =============================================================================
    handleChange (e, prop){
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        switch (prop) {
            case 'currency':
                this.setState({
                    [prop]: value,
                    show_fx_rate: value !== 'IDR',
                }, () => {
                    this.calculateTotalExpenses();
                });
                break;
            case 'fx_rate':
                this.setState({ [prop]: value }, () => this.calculateTotalExpenses());
                break;
            default:
                this.setState({ [prop]: value });
                break;
        }
    };

    handleDate (date, prop){
        this.setState({ [prop]: date });
    };

    handleDate (date, prop){
        this.setState({ [prop]: date });
    };

    // =============================================================================
    // Project detail form submit
    // =============================================================================
    handleSubmit = (e) => {
        e.preventDefault();

        if (!validator.allValid()) {
            this.setState({ errors: validator.getErrorMessages() });
            return false;
        }

        this.setState({ errors: {}, loadingButton: true });

        let temp = [];
        if(this.state.underwriter.length > 0) {
            _.forEach(this.state.underwriter, function(v){ temp.push(v.id) });
        }

        let params = {
            case_number : this.state.case_number,
            project_number : this.state.project_number,
            ext_project_number : this.state.ext_project_number,
            case_type : this.state.case_type,
            type_id : this.state.type_id,
            detail_type_id : this.state.detail_type_id,
            vessel_name : this.state.vessel_name,
            vessel_type_id : this.state.vessel_type_id,
            vessel_grt : this.state.vessel_grt,
            vessel_yob : this.state.vessel_yob,
            engine_particular_hp : this.state.engine_particular_hp,
            broker : this.state.broker,
            adjuster : this.state.adjuster,
            shipowner : this.state.shipowner,
            instructor : this.state.instructor,
            underwriter : temp,
            casualty: this.state.casualty,
            casualty_type_id: this.state.casualty_type_id,
            place_of_accident: this.state.place_of_accident,
            instruction_date: this.state.instruction_date,
            date_of_accident: this.state.date_of_accident,
            instruction_by: this.state.instruction_by,
            pic_case: this.state.pic_case,
            currency: this.state.currency,
            currency_rate: this.state.currency_rate,
            hard_copy_invoice: this.state.hard_copy_invoice,
            hard_copy_report: this.state.hard_copy_report,
            soft_copy_data: this.state.soft_copy_data,
        };

        Api.patch('/projects/'+this.props.match.params.id, params, false).then(resp => {
            this.setState({ loadingButton: false });
            this.showMessage(true, 'Project updated');
        }).catch(err => {
            if (ErrorHandling.checkErrorTokenExpired(err)){

            } else {
                this.setState({ errors: err.errors, loadingButton: false });
                this.showMessage(false, 'Invalid format data');
            }
        });
    };

    // =============================================================================
    // Status panels: edit toggles & submit (project / survey)
    // =============================================================================
    handleEditStatus = () => {
        let date = Date.now();
        this.setState({ editStatus: true, date_status: date });
    };

    handleEditStatusCase = () => {
        this.setState({
            editStatusCase: true,
            case_date_status: Date.now(),
        });
    };

    handleEditStatusSurvey = () => {
        this.setState({ editSurvey: true });
    };

    handleCancelEditStatusCase = () => {
        this.setState({ editStatusCase: false });
    };

    handleCancelEditStatusSurvey = () => {
        this.setState({ editSurvey: false });
    };

    handleCancelEditStatus = () => {
        this.setState({ editStatus: false });
    };

    handleSubmitStatus = (e) => {
        e.preventDefault();

        if (!validatorProject.allValid()) {
            this.setState({ errors: validatorProject.getErrorMessages() });
            return false;
        }

        this.setState({ errors: {}, loadingProject: true });

        let params = {
            date_status: moment(this.state.date_status).format('YYYY-MM-DD'),
            project_status_id: this.state.project_status_id,
            comment: this.state.comment,
        };

        Api.patch('/projects/'+this.props.match.params.id, params, false).then(resp => {
            this.setState({
                loadingProject: false,
                editStatus: false,
                project_status_id: resp.data.projectStatus ? resp.data.projectStatus.id : '',
                project_status_name: resp.data.projectStatus ? resp.data.projectStatus.name : '',
                date_status: resp.data.dateStatus,
                comment: resp.data.projectStatusComment,
            }, () => {
                let param = {
                    projects_id: this.props.match.params.id,
                    user_id: this.state.user_id_current,
                    type: 'comment',
                    comment: resp.data.projectStatus.name+' dilakukan pada tanggal '+resp.data.dateStatus,
                };

                Api.post('/comments', param, false).then(resp => {
                    this.__fetchComment();
                    this.__fetch();
                    this.showMessage(true, 'Status updated');
                }).catch(err => {
                    this.setState(
                        { errors: err.errors, loadingComment: false },
                        () =>  this.__fetchComment()
                    );
                    this.showMessage(false, 'Invalid format data');
                });
            })
        }).catch(err => {
            this.setState({ errors: err.errors, loadingProject: false });
            this.showMessage(false, 'Invalid format data');
        });
    };
    handleSubmitStatusSurvey = (e) => {
        e.preventDefault();

        if (!validatorSurvey.allValid()) {
            this.setState({ errors: validatorSurvey.getErrorMessages() });
            return false;
        }

        this.setState({  errors: {}, loadingSurvey: true });

        let params = {
            date_survey_status: moment(this.state.date_survey_status).format('YYYY-MM-DD'),
            survey_status_id: this.state.survey_status_id,
            survey_comment: this.state.survey_comment,
            survey_remarks: this.state.survey_remarks,
        };

        Api.patch('/projects/'+this.props.match.params.id, params, false).then(resp => {
            this.setState({
                loadingSurvey: false,
                    editSurvey: false,
                    survey_status_name: resp.data.surveyStatus ? resp.data.surveyStatus.name : '',
                    survey_status_id: resp.data.surveyStatus ? resp.data.surveyStatus.id : '',
                    survey_comment: resp.data.surveyComment ? resp.data.surveyComment : '',
                    survey_remarks: resp.data.surveyRemarks ? resp.data.surveyRemarks : '',
                    date_survey_status: resp.data.dateSurveyStatus,
                }, () =>  {

                let param = {
                    projects_id: this.props.match.params.id,
                    user_id: this.state.user_id_current,
                    type: 'comment',
                    comment: resp.data.surveyStatus.name+' dilakukan pada tanggal '+resp.data.dateSurveyStatus,
                };

                Api.post('/comments', param, false).then(resp => {

                    if(resp.data)
                    this.__fetchComment();
                    this.__fetch();
                    this.showMessage(true, 'Status updated');
                }).catch(err => {
                    this.setState({
                        errors: err.errors,
                        loadingComment: false
                    }, () => {
                        this.__fetchComment();
                    });

                    this.showMessage(false, 'Invalid format data');
                });
            });

        }).catch(err => {
            if (ErrorHandling.checkErrorTokenExpired(err)){

            } else {
                this.setState({ errors: err.errors, loadingSurvey: false });
                this.showMessage(false, 'Invalid format data');
            }
        });
    };

    // =============================================================================
    // Project summary & legacy approval-summary PATCH
    // =============================================================================
    handleSubmitProjectSummary = (e) => {
        e.preventDefault();

        if (!validatorProjectSummary.allValid()) {
            this.setState({ errors: validatorProjectSummary.getErrorMessages() });
            return false;
        }
        this.setState({ errors: {}, loadingProjectSummary: true });

        let params = {
            projectSummary: this.state.project_summary,
        };

        Api.patch('/projects/'+this.props.match.params.id, params, false).then(resp => {
            this.setState({
                loadingProjectSummary: false,
            }, () => {
                this.__fetch();
                this.showMessage(true, 'Project Summary updated');
            })
        }).catch(err => {
            this.setState({ errors: err.errors, loadingProjectSummary: false });
            this.showMessage(false, 'Failed to update Project Summary');
        });
    };

    handleSubmitSummaryOfCost = (e) => {
        e.preventDefault();

        if (!validatorProjectSummary.allValid()) {
            this.setState({ errors: validatorProjectSummary.getErrorMessages() });
            return false;
        }
        this.setState({ errors: {}, loadingSummaryOfCost: true });

        let params = {
            place_of_repair: this.state.place_of_repair || null,
            summary_of_cost: this.state.summary_of_cost || null,
            salvage_check: this.state.salvage_check == true || this.state.salvage_check == 1 ? 1 : 0,
            salvage_remarks: this.state.salvage_remarks || null,
            repair_check: this.state.repair_check == true || this.state.repair_check == 1 ? 1 : 0,
            repair_remarks: this.state.repair_remarks || null,
            replace_check: this.state.replace_check == true || this.state.replace_check == 1 ? 1 : 0,
            replace_remarks: this.state.replace_remarks || null,
            incoming_approval_check: this.state.incoming_approval_check == true || this.state.incoming_approval_check == 1 ? 1 : 0,
            allegation_check: this.state.allegation_check == true || this.state.allegation_check == 1 ? 1 : 0,
            allegation_remarks: this.state.allegation_remarks || null,
            claim_document_check: this.state.claim_document_check == true || this.state.claim_document_check == 1 ? 1 : 0,
            claim_document_remarks: this.state.claim_document_remarks || null,
            warranty_check: this.state.warranty_check == true || this.state.warranty_check == 1 ? 1 : 0,
            warranty_remarks: this.state.warranty_remarks || null,
        };

        Api.patch('/projects/'+this.props.match.params.id, params, false).then(resp => {
            this.setState({
                loadingSummaryOfCost: false,
            }, () => {
                this.__fetch();
                this.showMessage(true, 'Approval Summary updated');
            })
        }).catch(err => {
            this.setState({ errors: err.errors, loadingSummaryOfCost: false });
            this.showMessage(false, 'Failed to update Approval Summary');
        });
    };

    // =============================================================================
    // Comments (post)
    // =============================================================================
    handleCommentClient = (e) => {
        e.preventDefault();

        if (!validatorCommentClient.allValid()) {
            this.setState({ errors: validatorCommentClient.getErrorMessages() });
            return false;
        }

        this.setState({ errors: {}, loadingComment: true });

        let param = {
            projects_id: this.props.match.params.id,
            user_id: this.state.user_id_current,
            type: 'comment',
            comment: this.state.client_comment,
        };

        Api.post('/client-comments', param, false).then(resp => {
            if (resp.data) {
                this.__fetchComment();
                this.setState({ loadingComment: false });
                this.showMessage(true, 'Comment posted');
            }
        }).catch(err => {
            this.setState({ errors: err.errors, loadingComment: false });
            this.showMessage(false, 'Invalid format data');
        });
    };

    handleComment = (e) => {
        e.preventDefault();

        if (!validatorComment.allValid()) {
            this.setState({ errors: validatorComment.getErrorMessages() });
            return false;
        }

        this.setState({ errors: {}, loadingComment: true });

        let formData = new FormData();
        formData.append('projects_id', this.props.match.params.id);
        formData.append('user_id', this.state.user_id_current);
        formData.append('type', 'comment');
        formData.append('comment', this.state.user_comment);
        formData.append('image', this.state.image);

        Api.putFile('/comments',{
            method: 'POST',
            body: formData
        }).then(() => {
            this.setState({
                loadingComment: false,
                image: null,
                photo: null,
                user_comment: '',
            },
                () =>  this.__fetchComment()
            );

            this.showMessage(true, 'Comment posted');
        }).catch(err => {
            let message = 'Invalid format data';
            if (err?.errors?.comment?.[0]) message = err.errors.comment[0];

            this.setState(
                { errors: err.errors, loadingComment: false }, 
                () =>  this.__fetchComment()
            );
            this.showMessage(false, message);
        });
    };

    // =============================================================================
    // Lifecycle: multiple case status
    // =============================================================================
    // START - Multiple Case Status (master: GET /lifecycle/cases-status-master; pivot: GET/POST sync …/case-status-items)
    handleAddNewMultipleCaseStatus = () => {
        this.setState({ errors: {} });
        const temp = {
            id: undefined,
            cases_status_id: '',
            notes: '',
        };

        this.setState({ case_status_multiple: [...this.state.case_status_multiple, temp] });
    };

    handleDeleteMultipleCaseStatus (selectedIdx){
        let data = this.state.case_status_multiple.filter((e, idx) => idx !== selectedIdx);
        this.setState({  errors: {}, case_status_multiple: data });
    };

    handleChangeMultipleCaseStatus = (e, prop, id) => {
        const value = e.target.value;
        const data = this.state.case_status_multiple.map((row, k) => {
            if (k !== id) return row;
            return { ...row, [prop]: value };
        });

        this.setState({ errors: {}, case_status_multiple: data });
    };

    handleSaveMultipleCaseStatus = (e) => {
        if (e && e.preventDefault) e.preventDefault();

        const rows = this.state.case_status_multiple;
        let valid = true;
        rows.forEach((item, idx) => {
            if (!item.cases_status_id) valid = false;
        });
        if (!valid) {
            this.showMessage(false, 'Please select a case status for each row');
            return false;
        }

        const masterIds = rows.map((r) => r.cases_status_id).filter(Boolean);
        if (new Set(masterIds).size !== masterIds.length) {
            this.showMessage(false, 'Each case status may only appear once');
            return false;
        }

        const projectId = this.props.match.params.id;
        const items = rows.map((row) => {
            const item = {
                cases_status_id: row.cases_status_id,
                notes: row.notes && String(row.notes).trim() !== '' ? row.notes : null,
            };
            if (row.id) item.id = row.id;
            return item;
        });

        this.setState({ errors: {}, loadingCaseStatusMultiple: true });

        Api.post(`/projects/${projectId}/lifecycle/case-status-items/sync`, { items }).then((resp) => {
            const raw = resp.data;
            const list = Array.isArray(raw) ? raw : (raw?.data || []);
            const case_status_multiple = list.map((row) => ({
                id: row.id,
                cases_status_id: row.cases_status_id ?? row.casesStatusId ?? '',
                notes: row.notes != null ? String(row.notes) : '',
            }));
            this.setState({
                loadingCaseStatusMultiple: false,
                case_status_multiple,
            }, () => {
                this.showMessage(true, 'Case status updated');
                this.__fetch();
            });
        }).catch(err => {
            if (ErrorHandling.checkErrorTokenExpired(err)) {
                this.setState({ loadingCaseStatusMultiple: false });
            } else {
                this.setState({
                    errors: err.errors || {},
                    loadingCaseStatusMultiple: false,
                });
                this.showMessage(false, err.message || 'Could not update case status');
            }
        });

        return false;
    };
    // END - Multiple Case Status

    // =============================================================================
    // Lifecycle: multiple case survey status
    // =============================================================================
    // START - Multiple Case Survey Status (master: GET /lifecycle/case-survey-status-master; pivot: GET/POST sync …/case-survey-status-items)
    handleAddNewMultipleCaseSurveyStatus = () => {
        this.setState({ errors: {} });
        const temp = {
            id: undefined,
            case_survey_status_id: '',
            notes: '',
        };

        this.setState({ case_survey_status_multiple: [...this.state.case_survey_status_multiple, temp] });
    };

    handleDeleteMultipleCaseSurveyStatus = (selectedIdx) => {
        let data = this.state.case_survey_status_multiple.filter((e, idx) => idx !== selectedIdx);
        this.setState({ errors: {}, case_survey_status_multiple: data });
    };

    handleChangeMultipleCaseSurveyStatus = (e, prop, id) => {
        const value = e.target.value;
        const data = this.state.case_survey_status_multiple.map((row, k) => {
            if (k !== id) return row;
            return { ...row, [prop]: value };
        });

        this.setState({ errors: {}, case_survey_status_multiple: data });
    };

    handleSaveMultipleCaseSurveyStatus = (e) => {
        if (e && e.preventDefault) e.preventDefault();

        const rows = this.state.case_survey_status_multiple;
        if (rows.some((item) => !item.case_survey_status_id)) {
            this.showMessage(false, 'Please select a survey status for each row');
            return false;
        }

        const masterIds = rows.map((r) => r.case_survey_status_id).filter(Boolean);
        if (new Set(masterIds).size !== masterIds.length) {
            this.showMessage(false, 'Each survey status may only appear once');
            return false;
        }

        const projectId = this.props.match.params.id;
        const items = rows.map((row) => {
            const item = {
                case_survey_status_id: row.case_survey_status_id,
                notes: row.notes && String(row.notes).trim() !== '' ? row.notes : null,
            };
            if (row.id) item.id = row.id;
            return item;
        });

        this.setState({ errors: {}, loadingCaseSurveyStatusMultiple: true });

        Api.post(`/projects/${projectId}/lifecycle/case-survey-status-items/sync`, { items }).then((resp) => {
            const raw = resp.data;
            const list = Array.isArray(raw) ? raw : (raw?.data || []);
            const case_survey_status_multiple = list.map((row) => ({
                id: row.id,
                case_survey_status_id: row.case_survey_status_id ?? row.caseSurveyStatusId ?? row.survey_status_id ?? row.surveyStatusId ?? '',
                notes: row.notes != null ? String(row.notes) : '',
            }));
            this.setState({
                loadingCaseSurveyStatusMultiple: false,
                case_survey_status_multiple,
            }, () => {
                this.showMessage(true, 'Survey status updated');
                this.__fetch();
            });
        }).catch(err => {
            if (ErrorHandling.checkErrorTokenExpired(err)) {
                this.setState({ loadingCaseSurveyStatusMultiple: false });
            } else {
                this.setState({
                    errors: err.errors || {},
                    loadingCaseSurveyStatusMultiple: false,
                });
                this.showMessage(false, err.message || 'Could not update survey status');
            }
        });

        return false;
    };
    // END - Multiple Case Survey Status

    // =============================================================================
    // Lifecycle: multiple approval status
    // =============================================================================
    // START - Multiple Approval Status (master: /lifecycle/approval-status-master; pivot sync …/approval-status-items/sync)
    handleAddNewMultipleApprovalStatus = () => {
        this.setState({ errors: {} });
        const temp = {
            id: undefined,
            approval_status_id: '',
            remarks: '',
        };

        this.setState({ approval_status_multiple: [...this.state.approval_status_multiple, temp] });
    };

    handleDeleteMultipleApprovalStatus = (selectedIdx) => {
        let data = this.state.approval_status_multiple.filter((e, idx) => idx !== selectedIdx);
        this.setState({ errors: {}, approval_status_multiple: data });
    };

    handleChangeMultipleApprovalStatus = (e, prop, id) => {
        const value = e.target.value;
        const data = this.state.approval_status_multiple.map((row, k) => {
            if (k !== id) return row;
            return { ...row, [prop]: value };
        });

        this.setState({ errors: {}, approval_status_multiple: data });
    };

    handleSaveMultipleApprovalStatus = (e) => {
        if (e && e.preventDefault) e.preventDefault();

        const rows = this.state.approval_status_multiple;
        if (rows.some((item) => !item.approval_status_id)) {
            this.showMessage(false, 'Please select an approval status for each row');
            return false;
        }

        const masterIds = rows.map((r) => r.approval_status_id).filter(Boolean);
        if (new Set(masterIds).size !== masterIds.length) {
            this.showMessage(false, 'Each approval status may only appear once');
            return false;
        }

        const projectId = this.props.match.params.id;
        const items = rows.map((row) => {
            const item = {
                approval_status_id: row.approval_status_id,
                remarks: row.remarks && String(row.remarks).trim() !== '' ? row.remarks : null,
            };
            if (row.id) item.id = row.id;
            return item;
        });

        this.setState({ errors: {}, loadingApprovalStatusMultiple: true });

        Api.post(`/projects/${projectId}/lifecycle/approval-status-items/sync`, { items }).then((resp) => {
            const raw = resp.data;
            const list = Array.isArray(raw) ? raw : (raw?.data || []);
            const approval_status_multiple = list.map((row) => ({
                id: row.id,
                approval_status_id: row.approval_status_id ?? row.approvalStatusId ?? '',
                remarks: row.remarks != null ? String(row.remarks) : '',
            }));
            this.setState({
                loadingApprovalStatusMultiple: false,
                approval_status_multiple,
            }, () => {
                this.showMessage(true, 'Approval status updated');
                this.__fetch();
            });
        }).catch(err => {
            if (ErrorHandling.checkErrorTokenExpired(err)) {
                this.setState({ loadingApprovalStatusMultiple: false });
            } else {
                this.setState({
                    errors: err.errors || {},
                    loadingApprovalStatusMultiple: false,
                });
                this.showMessage(false, err.message || 'Could not update approval status');
            }
        });

        return false;
    };
    // END - Multiple Approval Status

    // =============================================================================
    // Lifecycle: multiple summary of cost
    // =============================================================================
    // START - Multiple Summary Of Cost (master: /lifecycle/summary-of-cost-master; pivot sync …/summary-of-cost-items/sync)
    parseSummaryOfCostDecimal = (v) => {
        if (v === '' || v === null || v === undefined) return null;
        const n = parseFloat(String(v).replace(/,/g, ''));
        return Number.isFinite(n) ? n : null;
    };

    handleAddNewMultipleSummaryOfCost = () => {
        this.setState({ errors: {} });
        const temp = {
            id: undefined,
            summary_of_cost_id: '',
            report_estimation: '',
            claim_from_owner_in_approval: '',
            remarks: '',
        };

        this.setState({ summary_of_cost_multiple: [...this.state.summary_of_cost_multiple, temp] });
    };

    handleDeleteMultipleSummaryOfCost = (selectedIdx) => {
        let data = this.state.summary_of_cost_multiple.filter((e, idx) => idx !== selectedIdx);
        this.setState({ errors: {}, summary_of_cost_multiple: data });
    };

    handleChangeMultipleSummaryOfCost = (e, prop, id) => {
        const value = e.target.value;
        const data = this.state.summary_of_cost_multiple.map((row, k) => {
            if (k !== id) return row;
            return { ...row, [prop]: value };
        });

        this.setState({ errors: {}, summary_of_cost_multiple: data });
    };

    maybeAutofillSummaryOfCostDefaults = () => {
        const defaultNames = this.state.multiple_summary_of_cost_options_list || MULTIPLE_SUMMARY_OF_COST_DEFAULT_LIST;
        const masters = this.state.summary_of_cost_master || [];
        if (!masters.length) return;

        const resolveId = (label) =>
            masters.find(x => (x.name || '').trim().toLowerCase() === String(label).trim().toLowerCase())?.id;

        const rows = this.state.summary_of_cost_multiple || [];
        const missing = defaultNames.some((desc) => {
            const mid = resolveId(desc);
            if (!mid) return false;
            return !rows.some((e) => e.summary_of_cost_id === mid);
        });
        if (missing) this.handleAutofillDefaultSummaryOfCostMultiple();
    };

    handleSaveMultipleSummaryOfCost = (e) => {
        if (e && e.preventDefault) e.preventDefault();

        const rows = this.state.summary_of_cost_multiple;
        if (rows.some((item) => !item.summary_of_cost_id)) {
            this.showMessage(false, 'Please select a summary of cost item for each row');
            return false;
        }

        const masterIds = rows.map((r) => r.summary_of_cost_id).filter(Boolean);
        if (new Set(masterIds).size !== masterIds.length) {
            this.showMessage(false, 'Each summary of cost line may only appear once');
            return false;
        }

        const projectId = this.props.match.params.id;
        const parse = this.parseSummaryOfCostDecimal;
        const items = rows.map((row) => {
            const item = {
                summary_of_cost_id: row.summary_of_cost_id,
                report_estimation: parse(row.report_estimation),
                claim_from_owner_in_approval: parse(row.claim_from_owner_in_approval),
                remarks: row.remarks && String(row.remarks).trim() !== '' ? row.remarks : null,
            };
            if (row.id) item.id = row.id;
            return item;
        });

        this.setState({ errors: {}, loadingSummaryOfCostMultiple: true });

        Api.post(`/projects/${projectId}/lifecycle/summary-of-cost-items/sync`, { items }).then((resp) => {
            const raw = resp.data;
            const list = Array.isArray(raw) ? raw : (raw?.data || []);
            const formatSocNum = (v) => {
                if (v === null || v === undefined || v === '') return '';
                const n = typeof v === 'number' ? v : parseFloat(String(v).replace(/,/g, ''));
                return Number.isFinite(n) ? String(n) : '';
            };
            const summary_of_cost_multiple = list.map((row) => ({
                id: row.id,
                summary_of_cost_id: row.summary_of_cost_id ?? row.summaryOfCostId ?? '',
                report_estimation: formatSocNum(row.report_estimation ?? row.reportEstimation),
                claim_from_owner_in_approval: formatSocNum(row.claim_from_owner_in_approval ?? row.claimFromOwnerInApproval),
                remarks: row.remarks != null ? String(row.remarks) : '',
            }));
            this.setState({
                loadingSummaryOfCostMultiple: false,
                summary_of_cost_multiple,
            }, () => {
                this.showMessage(true, 'Summary of cost updated');
                this.__fetch();
            });
        }).catch(err => {
            if (ErrorHandling.checkErrorTokenExpired(err)) {
                this.setState({ loadingSummaryOfCostMultiple: false });
            } else {
                this.setState({
                    errors: err.errors || {},
                    loadingSummaryOfCostMultiple: false,
                });
                this.showMessage(false, err.message || 'Could not update summary of cost');
            }
        });

        return false;
    };
    // END - Multiple Summary Of Cost
    handleAutofillDefaultSummaryOfCostMultiple = () => {
        const defaultNames = this.state.multiple_summary_of_cost_options_list || MULTIPLE_SUMMARY_OF_COST_DEFAULT_LIST;
        const masters = this.state.summary_of_cost_master || [];
        let summary_of_cost_multiple = [...(this.state.summary_of_cost_multiple || [])];

        defaultNames.forEach((label) => {
            const master = masters.find(
                (x) => (x.name || '').trim().toLowerCase() === String(label).trim().toLowerCase()
            );
            if (!master) return;
            if (!summary_of_cost_multiple.some((e) => e.summary_of_cost_id === master.id)) {
                summary_of_cost_multiple.push({
                    id: undefined,
                    summary_of_cost_id: master.id,
                    report_estimation: '',
                    claim_from_owner_in_approval: '',
                    remarks: '',
                });
            }
        });

        this.setState({ summary_of_cost_multiple });
    };

    // =============================================================================
    // Expenses
    // =============================================================================
    calculateExpenseIDRAmount = (selectedAmount) => {
        if (!this.state.show_fx_rate) return 0;
        return selectedAmount * (this.state.fx_rate || 0);
    };

    calculateTotalExpenses = () => {
        let totalSurveyExpenses = 0;
        let totalOfficeExpenses = 0;
        let totalUncategorizedExpenses = 0;
        let totalExpenses = 0;

        _.forEach(this.state.survey_expenses, function(v){
            totalSurveyExpenses += parseFloat(v.amount);
        });

        _.forEach(this.state.office_expenses, function(v){
            totalOfficeExpenses += parseFloat(v.amount);
        });

        _.forEach(this.state.uncategorized_expenses, function(v){
            totalUncategorizedExpenses += parseFloat(v.amount);
        });

        totalExpenses = totalSurveyExpenses + totalOfficeExpenses;

        this.setState({
            total_survey_expenses: totalSurveyExpenses,
            total_office_expenses: totalOfficeExpenses,
            total_expenses: totalExpenses,
            total_out: totalUncategorizedExpenses,
        });
    };

    handleNewExpense = (expenseType) => {
        this.setState({ errors: {} });
        let temp = {
            date : null,
            description : '',
            amount : '',
            currency : this.state.currency || '',
            remarks : '',
            survey_hour : '',
            type : 'out',
            type_expenses: expenseType,
        };

        if (expenseType === 'survey') {
            this.setState({ survey_expenses: [...this.state.survey_expenses, temp] });
        } else {
            this.setState({ office_expenses: [...this.state.office_expenses, temp] });
        }
    };

    handleNewAdvance = (e) => {
        this.setState({ errors: {} });

        let exp = this.state.expense;
        let temp = {
            date : null,
            description : '',
            amount : '',
            currency : '',
            remarks : '',
            survey_hour : '',
            type : 'in',
        };

        exp.push(temp);
        this.setState({ expense: exp });
    };

    handleAutofillDefaultExpenses = () => {
        const defaultSurveyExpenses = SURVEY_EXPENSE_DESCRIPTIONS.map(desc => {
            return {
                description: desc,
                amount: 0,
                remarks: '',
                date: null,
                currency: this.state.currency || '',
                survey_hour: '',
                type: 'out',
                type_expenses: 'survey'
            };
        });

        let survey_expenses = this.state.survey_expenses ? [...this.state.survey_expenses] : [];
        defaultSurveyExpenses.forEach(item => {
            if (!survey_expenses.some(e => e.description && e.description.trim().toLowerCase() === item.description.toLowerCase())) {
                survey_expenses.push({ ...item });
            }
        });

        this.setState({ survey_expenses });
    };
    handleChangeExpenseSurvey = (e, prop, id) => {
        let data = this.state.survey_expenses;

        _.forEach(data, function(v,k){
            if (k === id) {
                if (prop === 'date') v[prop] = e;
                else v[prop] = e.target.value;
            }
        });

        this.setState({ errors: {}, survey_expenses: data });
    };

    handleDeleteExpenseSurvey (selectedIdx){
        let data = this.state.survey_expenses.filter((e, idx) => idx !== selectedIdx);
        this.setState({  errors: {}, survey_expenses: data });
    };

    handleChangeExpenseOffice = (e, prop, id) => {
        let data = this.state.office_expenses;

        _.forEach(data, function(v,k){
            if (k === id){
                if (prop === 'date') v[prop] = e;
                else v[prop] = e.target.value;
            }
        });

        this.setState({ errors: {}, office_expenses: data });
    };

    handleDeleteExpenseOffice (selectedIdx){
        let data = this.state.office_expenses.filter((e, idx) => idx !== selectedIdx);
        this.setState({ errors: {}, office_expenses: data });
    };

    handleChangeExpenseUncategorized = (e, prop, id) => {
        let data = this.state.uncategorized_expenses;

        _.forEach(data, function(v,k){
            if (k === id){
                if (prop === 'date') v[prop] = e;
                else v[prop] = e.target.value;
            }
        });

        this.setState({ errors: {}, uncategorized_expenses: data });
    };

    handleDeleteExpenseUncategorized (selectedIdx){
        let data = this.state.uncategorized_expenses.filter((e, idx) => idx !== selectedIdx);
        this.setState({  errors: {}, uncategorized_expenses: data });
    };

    handleSaveExpenses = (e) => {
        e.preventDefault();
        this.setState({ errors: {}, loadingSave: true });

        // Expense is not submitted when "date" is empty and "amount" is zero
        let allExpenses = [];

        if (this.state.survey_expenses.length > 0) {
            _.forEach(this.state.survey_expenses, function(v){
                if ((!v.date || v.date === '') && (!v.amount || Number(v.amount) === 0)) return;
                if (v?.date) v.date = moment(v.date).format('YYYY-MM-DD');
                if (v?.typeExpenses) {
                    v.type_expenses = v.typeExpenses;
                    delete v.typeExpenses;
                }
                allExpenses.push(v)
            });
        }

        if (this.state.office_expenses.length > 0) {
            _.forEach(this.state.office_expenses, function(v){
                if ((!v.date || v.date === '') && (!v.amount || Number(v.amount) === 0)) return;
                if (v?.date) v.date = moment(v.date).format('YYYY-MM-DD');
                if (v?.typeExpenses) {
                    v.type_expenses = v.typeExpenses;
                    delete v.typeExpenses;
                }
                allExpenses.push(v)
            });
        }

        if (this.state.uncategorized_expenses.length > 0) {
            _.forEach(this.state.uncategorized_expenses, function(v){
                if ((!v.date || v.date === '') && (!v.amount || Number(v.amount) === 0)) return;
                if (v.date) v.date = moment(v.date).format('YYYY-MM-DD');
                v.type_expenses = null;
                allExpenses.push(v)
            });
        }

        let params = {
            projects_id : this.props.match.params.id,
            expense : allExpenses,
        };
        
        Api.post('/expenses', params, false).then(resp => {
            this.setState({ loadingSave: false });
            this.showMessage(true, 'Successfully updated expenses');

            let param = {
                total_survey_hour: this.state.survey_hours,
                survey_days : this.state.survey_days,
                fx_rate: this.state.fx_rate,
                total_survey_expenses: this.state.total_survey_expenses,
                total_office_expenses: this.state.total_office_expenses,
                total_expenses: this.state.total_expenses,
            };

            Api.patch('/projects/'+this.props.match.params.id, param, false).then(resp => {
                this.__fetch();
            }).catch(err => {
                this.setState({ errors: err.errors, loadingSave: false });
            });
        }).catch(err => {
            if (ErrorHandling.checkErrorTokenExpired(err)) {
            } else {
                this.setState({ errors: err.errors, loadingSave: false });
                this.showMessage(false, 'Invalid format data');
            }
        });
    };

    NumberFormatCustom = (props) => {
        const { inputRef, onChange, ...other } = props;

        return (
            <NumberFormat
                {...other}
                getInputRef={inputRef}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                decimalScale={2}
                fixedDecimalScale={true}
                thousandSeparator
                isNumericString
            />
        );
    };

    // =============================================================================
    // Dialogs: cancel, revert, delete project
    // =============================================================================
    handleOpen = () => {
        this.setState({ showDialog: true });
    };

    handleClose = () => {
        this.setState({ showDialog: false });
    };

    handleOpenRevert = () => {
        this.setState({ showDialogRevert: true });
    };

    handleCloseRevert = () => {
        this.setState({ showDialogRevert: false });
    };

    handleOpenDelete = () => {
        this.setState({ showDialogDelete: true });
    };

    handleCloseDelete = () => {
        this.setState({ showDialogDelete: false });
    };

    handleCancel = () => {
        this.setState({ loadingButton: true });
        let params = {
            cancel_status : 1,
        };

        Api.patch('/projects/'+this.props.match.params.id, params, false).then(resp => {
            this.setState({
                loadingButton: false,
                showDialog :false,
            }, () => {
                this.__fetch();
            });

            this.showMessage(true, 'Project Canceled');
        }).catch(err => {
            this.setState({ errors: err.errors, loadingButton: false, showDialog :false });
            this.showMessage(false, 'Invalid format data');
        });
    };

    handleRevert = () => {
        this.setState({ loadingButton: true });
        let params = {
            cancel_status : 0,
        };

        Api.post('/projects/'+this.props.match.params.id+'/cancel-status', params, false).then(resp => {
            this.setState({
                loadingButton: false,
                showDialogRevert :false,
            }, () => {
                this.__fetch();
            });

            this.showMessage(true, 'Project Canceled');
        }).catch(err => {
            this.setState({ errors: err.errors, loadingButton: false, showDialogRevert :false });
            this.showMessage(false, 'Invalid format data');
        });
    };

    handleDelete = () => {
        this.setState({ loadingButton: true });

        Api.delete('/projects/'+this.props.match.params.id, '', false).then(resp => {
            this.setState({
                showDialogDelete: false,
                loadingButton :false,
            }, () => {
                this.__fetch();
            });

            this.showMessage(true, 'Project successfully deleted');
        }).catch(err => {
            this.setState({
                showDialogDelete: false,
                loadingButton :false,
            }, () => {
                this.__fetch();
            });
            this.showMessage(true, 'Project successfully deleted');
        });
    };

    // =============================================================================
    // Comments (delete) & avatar
    // =============================================================================
    handleDeleteComment = () => {
        this.setState({ loadingButton: true });

        Api.delete('/comments/'+this.state.idDelete, '', false).then(resp => {
            this.setState({
                    showDialogDeleteComment :false,
                    loadingButton :false,
                },
                () => this.__fetchComment()
            );

            this.showMessage(true, 'Comment successfully deleted');


        }).catch(err => {

            this.setState({
                    showDialogDeleteComment: false,
                    loadingButton :false,
                },
                () =>  this.__fetchComment()
            );

            this.showMessage(true, 'Comment successfully deleted');
        });
    };

    handleDeleteCommentClient = () => {

        this.setState({
                loadingButton: true,
            }
        );

        Api.delete('/client-comments/'+this.state.idDelete, '', false).then(resp => {

            this.setState({
                    showDialogDeleteComment :false,
                    loadingButton :false,
                },
                () => this.__fetchComment()
            );

            this.showMessage(true, 'Comment successfully deleted');


        }).catch(err => {

            this.setState({
                    showDialogDeleteComment: false,
                    loadingButton :false,
                },
                () =>  this.__fetchComment()
            );

            this.showMessage(true, 'Comment successfully deleted');
        });
    };

    handleAvatar = e => {
        this.setState({
            photo: URL.createObjectURL(e.target.files[0]),
            image: e.target.files[0]
        });
    };

    handleOpenDeleteComment = (row, type) => {
        this.setState({
            showDialogDeleteComment :true,
            idDelete: row.id,
            typeDelete: type
        })
    };

    handleCloseComment = () => {
        this.setState({
            showDialogDeleteComment :false,
            idDelete: ''
        })
    };

    // =============================================================================
    // Render helpers
    // =============================================================================
    renderReportOrApproval = (type_id) => {
        if (type_id === PROJECT_TYPE_IDS.report) { // Report
            return (
                <div className='card-detail'>
                    <h3>Repair</h3>
                    {
                        (this.state.repairs && this.state.repairs.length > 0) 
                            ? (this.state.repairs || []).map((item, key) => (
                                <>
                                    <p>{item?.item || '-'}</p>
                                    <p>Currency: <span>{item?.currency || '-'}</span></p>
                                    <p>Value / Amount: <NumberFormat thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} value={item?.amount || 0} displayType={'text'} renderText={value => <span>{value}</span>}/></p>
                                    {/* <br /> */}
                                    {this.state.repairs.length !== (key + 1) && <hr />}
                                </>
                            )) : (
                                <p>No data</p>
                            )
                    }
                </div>
            );
        } else if (type_id === PROJECT_TYPE_IDS.approval) { // Approval
            return (
                <div className='card-detail'>
                    <h3>Estimate cost</h3>
                    {/* <p>Estimate Cost of Repair in Report: <NumberFormat thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} value={this.state.estimation_cost} displayType={'text'} renderText={value => <span>{value}</span>}/></p> */}
                    <p>Estimate Cost of Repair in Report: <span>{this.state.estimation_cost}</span></p>
                    <p>Place of Repair / Shipyard Location: <span>{this.state.place_of_repair}</span></p>
                    <p>Total Account Submitted: <span>{this.state.total_account_submitted}</span></p>
                    <p>Total Account Approved: <span>{this.state.total_account_approved}</span></p>
                    <p>Total Account Approved for Cost: <span>{this.state.total_account_approved_for_cost}</span></p>
                    <p>Total Account Approved with Comment: <span>{this.state.total_account_approved_with_comment}</span></p>
                    <p>Total Account Not Approved: <span>{this.state.total_account_not_approved}</span></p>
                    <p>Residual Scrap Value: <span>{this.state.residual_scrap_value}</span></p>
                </div>
            );
        } else {
            return (
                <div className='card-detail'>
                    <h3>Estimate cost</h3>
                    <p>Currency: <span>{this.state.currency}</span></p>
                    {/* <p>Estimate Cost of Repair in Report: <NumberFormat thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} value={this.state.estimation_cost} displayType={'text'} renderText={value => <span>{value}</span>}/></p> */}
                    <p>Estimate Cost of Repair in Report: <span>{this.state.estimation_cost}</span></p>
                </div>
            );
        }
    }

    // =============================================================================
    // Fallback: commented-out implementations (legacy / not wired)
    // =============================================================================
    // __fetchExpenses = () => {
    //     const id = this.props.match.params.id;

    //     Api.get('/expenses?search=projects_id:'+id).then(resp => {
    //         if (resp.data) {
    //             const survey_expenses = resp.data.filter(e => e?.typeExpenses === 'survey');
    //             const office_expenses = resp.data.filter(e => e?.typeExpenses === 'office');
    //             const uncategorized_expenses = resp.data.filter(e => (e?.typeExpenses === '' || e?.typeExpenses === null));
    //             this.setState({
    //                 survey_expenses,
    //                 office_expenses,
    //                 uncategorized_expenses,
    //                 total_in: resp.meta ? resp.meta.custom.totalIn : 0,
    //                 total_out: resp.meta ? resp.meta.custom.totalOut : 0,
    //                 saldo: resp.meta ? resp.meta.custom.saldo : 0,
    //             }, () => {
    //                 const defaultDescriptions = SURVEY_EXPENSE_DESCRIPTIONS;
    //                 const currentDescriptions = (this.state.survey_expenses || []).map(e => (e.description || '').trim().toLowerCase());
    //                 const missing = defaultDescriptions.some(desc => !currentDescriptions.includes(desc.toLowerCase()));
    //                 if (missing) {
    //                     this.handleAutofillDefaultExpenses();
    //                 }
    //             });
    //         }
    //     });
    // };

    // __fetchCaseStatus = (projectTypeId = null) => {
    //     Api.get('/cases-status?limit=0').then(resp => {
    //         if (resp.data) {
    //             let case_status = [];

    //             if (resp.data.length > 0) {
    //                 _.forEach(resp.data, function(v,i){
    //                     if (!projectTypeId) {
    //                         case_status.push(v);
    //                     } else if (projectTypeId === PROJECT_TYPE_IDS.approval) {
    //                         if (v.type.includes('Approval')) case_status.push(v);
    //                     } else if (projectTypeId === PROJECT_TYPE_IDS.report) {
    //                         if (v.type.includes('Report')) case_status.push(v);
    //                     }
    //                 });
    //             }

    //             this.setState({ case_status });
    //         }
    //     }).catch(err => {
    //         console.log(err);
    //     });
    // }
    // handleSubmitStatusCase = (e) => {
    //     e.preventDefault();

    //     if (!validatorProject.allValid()) {
    //         this.setState({ errors: validatorProject.getErrorMessages() });
    //         return false;
    //     }

    //     this.setState({ errors: {}, loadingCase: true });

    //     let params = {
    //         case_status_id: this.state.case_status_id,
    //     };

    //     Api.patch('/projects/'+this.props.match.params.id, params, false).then(resp => {
    //         this.setState({
    //             loadingCase: false,
    //             editStatusCase: false,
    //             case_status_id: resp.data.caseStatus ? resp.data.caseStatus.id : '',
    //             case_status_name: resp.data.caseStatus ? resp.data.caseStatus.name : '',
    //         }, () => {
    //             this.__fetch();
    //             this.showMessage(true, 'Status updated');
    //         })
    //     }).catch(err => {
    //         this.setState({ errors: err.errors, loadingCase: false });
    //         this.showMessage(false, 'Invalid format data');
    //     });
    // };

    // handleClearCaseStatus = (e) => {
    //     e.preventDefault();

    //     let params = {
    //         case_status_id: this.state.case_status_id,
    //         delete_case_status: this.state.case_status_id,
    //     };

    //     Api.patch('/projects/'+this.props.match.params.id, params, false).then(resp => {
    //         this.setState({
    //             loadingCase: false,
    //             editStatusCase: false,
    //             case_status_id: '',
    //             case_status_name: '',
    //         }, () => {
    //             this.__fetch();
    //             this.showMessage(true, 'Status updated');
    //         })
    //     }).catch(err => {
    //         this.setState({ errors: err.errors, loadingCase: false });
    //         this.showMessage(false, 'Invalid format data');
    //     });
    // };

    render() {
        return (
            <div className='row main-content'>
                <div className='col-12 px-lg-5'>
                    <h1 className='page-title'>Detail Project {this.state.type_id === PROJECT_TYPE_IDS.approval ? 'Approval' : 'Report'}</h1>
                    <nav aria-label='breadcrumb'>
                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'><Link to='/' >Home</Link></li>
                            <li className='breadcrumb-item'><Link to='/projects' >Project</Link></li>
                            <li className='breadcrumb-item active' aria-current='page'>Detail</li>
                        </ol>
                    </nav>

                </div>
                <div className='col-md-4 mt-md-3 pl-lg-5'>
                    <div className={'card-abadi '+this.filterStatus(this.state.top_project_status)}>
                        <div className='icon-img'>
                            <img src={StatusProject} alt='abadi' className='img-fluid' />
                        </div>
                        <div className='detail'>
                            <p>Project Status</p>
                            <h3>{this.state.top_project_status}</h3>
                        </div>
                    </div>
                </div>
                {
                    this.filterPermission('finance-projects') &&
                    <div className='col-md-4 mt-md-3'>
                        <div className={'card-abadi '+this.filterStatus(this.state.top_finance_status)}>
                            <div className='icon-img'>
                                <img src={StatusFinance} alt='finance' className='img-fluid' />
                            </div>
                            <div className='detail'>
                                <p>Finance Status</p>
                                <h3>{this.state.top_finance_status}</h3>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.filterPermission('finance-projects') &&
                    <div className='col-md-4 mt-md-3'>
                        <div className='card-abadi green'>
                            <div className='icon-img'>
                                <img src={StatusOS} alt='status' className='img-fluid' />
                            </div>
                            <div className='detail'>
                                <p>OS Invoice Amount</p>
                                <h3>
                                    <NumberFormat thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} value={this.state.top_os === null ? 0 : this.state.top_os} displayType={'text'} renderText={value => <span>{value}</span>}/>
                                </h3>
                            </div>
                        </div>
                    </div>
                }

                <div className='col-12'>
                    <div className='row'>
                        <div className='col-md-8 mt-3 pl-lg-5 detail-wrap'>
                            <div className='btn-group mb-3 mb-lg-4'>
                                <button className='btn-tab active'>
                                    Project Detail
                                </button>
                                {
                                    this.filterPermission('finance-projects') &&
                                    <button className='btn-tab' onClick={() => this.handleGo('/projects/finance/'+this.props.match.params.id)}>
                                        Finance Detail
                                    </button>
                                }
                            </div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    {
                                        this.state.loading ? (
                                            <div className='table-wrapper detail mb-3'>
                                                <h2 className='title-wrap'>Information</h2>
                                                <Skeleton variant='rect' className='mb-3' height={118} />
                                                <Skeleton variant='rect' className='mb-3' height={118} />
                                                <Skeleton variant='rect' className='mb-3' height={118} />
                                                <Skeleton variant='rect' className='mb-3' height={118} />
                                                <Skeleton variant='rect' className='mb-3' height={40} />
                                                <Skeleton variant='rect' className='mb-3' height={40} />
                                            </div> 
                                        ) : (
                                            <>
                                                <div className='table-wrapper detail mb-3'>
                                                    <h2 className='title-wrap'>Information</h2>
                                                    <div className='card-detail'>
                                                        <h3>Internal Data</h3>
                                                        <p>Case number: <span>{this.state.case_number}</span></p>
                                                        <p>Project number: <span>{this.state.project_number}</span></p>
                                                        <p>Ext project number: <span>{this.state.ext_project_number}</span></p>
                                                        <p>Case Type: <span>{this.state.case_type}</span></p>
                                                        <p>Project type: <span>{this.state.type}</span></p>
                                                        <p>Project detail type: <span>{this.state.detail_type}</span></p>
                                                        <p>Instruction date: <span>{this.state?.instruction_date ? moment(this.state.instruction_date).format('MMM, DD YYYY') : ''}</span></p>
                                                        <p>Approval Category: <span>{this.state?.approval_category?.name || ''}</span></p>
                                                    </div>
                                                    <div className='card-detail'>
                                                        <h3>Vessel Particular</h3>
                                                        <p>Vessel name: <span>{this.state.vessel_name}</span></p>
                                                        <p>Vessel type: <span>{this.state.vesselTypeData?.name ? this.state.vesselTypeData.name : (this?.state?.vesselType || '')}</span></p>
                                                        <p>Vessel GRT: <span>{this.state.vessel_grt}</span></p>
                                                        <p>Vessel YOB: <span>{this.state.vessel_yob}</span></p>
                                                        <p>ENGINE Particular HP : <span>{this.state.engine_particular_hp}</span></p>
                                                    </div>
                                                    <div className='card-detail'>
                                                        <h3>Client Detail</h3>
                                                        <p>Underwriter:
                                                            {
                                                                this.state.underwriters.length > 0 &&
                                                                this.state.underwriters.map(option => (
                                                                    <span className='d-block' key={option.id}>- {option.name}</span>
                                                                ))
                                                            }
                                                        </p>
                                                        <p>Broker: <span>{this.state.broker}</span></p>
                                                        <p>Shipwoner: <span>{this.state.shipowner}</span></p>
                                                        <p>Adjuster: <span>{this.state.adjuster}</span></p>
                                                        <p>Instructor: <span>{this.state.instructor}</span></p>
                                                    </div>
                                                    <div className='card-detail'>
                                                        <h3>Accidents</h3>
                                                        <p>Casualty: <span>{this.state.casualty}</span></p>
                                                        <p>Casualty Type: <span>{this.state?.casualtyType?.name}</span></p>
                                                        <p>Place of accident: <span>{this.state.place_of_accident}</span></p>
                                                        <p>Date of accident: <span>{this.state?.date_of_accident ? moment(this.state.date_of_accident).format('MMM, DD YYYY') : ''}</span></p>
                                                        <p>Instruction by: <span>{this.state.instruction_by}</span></p>
                                                    </div>
                                                    <div className='card-detail'>
                                                        <h3>Survey Data Internal</h3>
                                                        <p>Surveyor:
                                                            {
                                                                this.state.surveyor.length > 0 &&
                                                                this.state.surveyor.map(option => (
                                                                    <span className='d-block' key={option.id}>- {option.name}</span>
                                                                ))
                                                            }
                                                        </p>
                                                        <p>Report / Approval Handler:
                                                            {
                                                                this.state.admins.length > 0 &&
                                                                this.state.admins.map(option => (
                                                                    <span className='d-block' key={option.id}>- {option.name}</span>
                                                                ))
                                                            }
                                                        </p>
                                                        <p>Final Reviewer:
                                                            {
                                                                this.state.finalReviewer.length > 0 &&
                                                                this.state.finalReviewer.map(option => (
                                                                    <span className='d-block' key={option.id}>- {option.name}</span>
                                                                ))
                                                            }
                                                        </p>
                                                    </div>
                                                    <div className='card-detail'>
                                                        <h3>PIC</h3>
                                                        <p>PIC for survey arrangement: <span>{this.state.pic_case}</span></p>
                                                    </div>
                                                    <div className='card-detail'>
                                                        <h3>Filling Admin</h3>
                                                        {this.state.hard_copy_invoice === 1 && <p>Hard copy invoice sudah di print</p>}
                                                        {this.state.hard_copy_report === 1 && <p>Hard copy report sudah di print</p>}
                                                        {this.state.soft_copy_data === 1 && <p>Softcopy data sudah tersedia</p>}
                                                        {this.state.files?.length > 0 && (
                                                            <div>
                                                                <p>File Project :</p>
                                                                {
                                                                    this.state.files.map((item) => (
                                                                        <p>
                                                                            <a 
                                                                                href={process.env.REACT_APP_API_STORAGE_PATH + item.file_name}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                style={{ display: 'block', width: '100%' }}
                                                                            >
                                                                                <i className="fas fa-file"> </i> {item?.file_name}
                                                                            </a>
                                                                        </p>
                                                                    ))
                                                                }
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }

                                </div>
                                <div className='col-md-6'>
                                    <div className='card-edit mb-3'>
                                        <div className='row '>
                                            <div className='col-5 col-md-12 col-xl-5'>
                                                <img src={editImage} alt='edit' className='img-fluid' />
                                            </div>
                                            <div className='col-7 col-md-12 col-xl-7'>
                                                <p>UNTUK EDIT PROJEK SILAHKAN KLIK EDIT PROJECT</p>
                                                <Button
                                                    variant='contained'
                                                    color='secondary'
                                                    className='full mb-3'
                                                    onClick={() => this.handleGo('/projects/edit/'+this.props.match.params.id)}
                                                    disabled={this.state.loadingButton}
                                                >
                                                    Edit Project{ this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i> }
                                                </Button>
                                            </div>

                                        </div>


                                    </div>

                                    {/* Estimate Cost of Repair */}
                                    {/* <div className='table-wrapper detail mb-3'>
                                        <h2 className='title-wrap'>
                                            {this.state.type_id === PROJECT_TYPE_IDS.approval ? 'Summary of Claim / Approval' : 'Estimate Cost of Repair in Report'}
                                        </h2>
                                        {
                                            this.state.loading 
                                                ? <Skeleton variant='rect' className='mb-3' height={70} />
                                                : this.renderReportOrApproval(this.state.type_id)
                                        }
                                    </div> */}

                                    {/* Summary Of Cost */}
                                    {/* <div className='table-wrapper detail mb-3'>
                                        <h2 className='title-wrap'>Approval Summary</h2>
                                        <div className="card-detail">
                                            <h3 className="pl-3">Summary of Cost</h3>
                                            {this.state.type_id === PROJECT_TYPE_IDS.report && (
                                                <div className="form-group px-3 pt-3 mb-0">
                                                    <div className="d-flex">
                                                        <div>
                                                            <input
                                                                type="checkbox"
                                                                id="incoming_approval_check"
                                                                name="incoming_approval_check"
                                                                checked={this.state.incoming_approval_check}
                                                                onChange={e => this.handleChange(e, 'incoming_approval_check')}
                                                                style={{width: '20px', height: '20px'}}
                                                            />
                                                        </div>
                                                        <p className="p-0 ml-2 mb-2">Incoming Approval</p>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="form-group px-3 pt-3 mb-0">
                                                <TextField 
                                                    variant='outlined'
                                                    type='text'
                                                    id='place_of_repair'
                                                    name='place_of_repair'
                                                    label='Place of Repair / Shipyard Location'
                                                    onChange={(e) => this.handleChange(e, 'place_of_repair')}
                                                    value={this.state.place_of_repair}
                                                    fullWidth
                                                />
                                                {validatorSummaryOfCost.message('place_of_repair', this.state.place_of_repair, 'max:1500')}
                                                <div className='text-danger'>{this.state.errors?.place_of_repair}</div>
                                            </div>
                                            <div className="form-group px-3 pt-3">
                                                <TextField
                                                    label='Summary of Cost'
                                                    className="textarea-no-padding textarea-font-small"
                                                    variant="outlined"
                                                    color="primary"
                                                    type='text'
                                                    id='summary_of_cost'
                                                    name="summary_of_cost"
                                                    onChange={(e) => this.handleChange(e, 'summary_of_cost')}
                                                    placeholder="Write summary of project cost here"
                                                    value={this.state.summary_of_cost}
                                                    fullWidth
                                                    multiline
                                                    minRows={7}
                                                    maxRows={10}
                                                />
                                                {validatorSummaryOfCost.message('summary_of_cost', this.state.summary_of_cost, 'max:3000')}
                                                <div className='text-danger'>{this.state.errors.summary_of_cost}</div>
                                            </div>
                                            <div className="form-group px-3 mb-0">
                                                <div className="d-flex">
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="salvage_check"
                                                            name="salvage_check"
                                                            checked={this.state.salvage_check}
                                                            onChange={e => this.handleChange(e, 'salvage_check')}
                                                            style={{width: '20px', height: '20px'}}
                                                        />
                                                    </div>
                                                    <p className="p-0 ml-2 mb-2">Salvage</p>
                                                </div>
                                                <div>
                                                    <TextField
                                                        className="textarea-no-padding textarea-font-small"
                                                        variant="outlined"
                                                        color="primary"
                                                        type="text"
                                                        id="salvage_remarks"
                                                        name="salvage_remarks"
                                                        onChange={(e) => this.handleChange(e, 'salvage_remarks')}
                                                        placeholder="Salvage remarks"
                                                        value={this.state.salvage_remarks}
                                                        fullWidth
                                                        multiline
                                                        minRows={5}
                                                        maxRows={7}
                                                    />
                                                    {validatorSummaryOfCost.message('salvage_remarks', this.state.salvage_remarks, 'max:3000')}
                                                    <div className='text-danger'>{this.state.errors.salvage_remarks}</div>
                                                </div>
                                            </div>
                                            <div className="form-group px-3 pt-3 mb-0">
                                                <div className="d-flex">
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="repair_check"
                                                            name="repair_check"
                                                            checked={this.state.repair_check}
                                                            onChange={e => this.handleChange(e, 'repair_check')}
                                                            style={{width: '20px', height: '20px'}}
                                                        />
                                                    </div>
                                                    <p className="p-0 ml-2 mb-2">Repair</p>
                                                </div>
                                                <div>
                                                    <TextField
                                                        className="textarea-no-padding textarea-font-small"
                                                        variant="outlined"
                                                        color="primary"
                                                        type="text"
                                                        id="repair_remarks"
                                                        name="repair_remarks"
                                                        onChange={(e) => this.handleChange(e, 'repair_remarks')}
                                                        placeholder="Repair remarks"
                                                        value={this.state.repair_remarks}
                                                        fullWidth
                                                        multiline
                                                        minRows={5}
                                                        maxRows={7}
                                                    />
                                                    {validatorSummaryOfCost.message('repair_remarks', this.state.repair_remarks, 'max:3000')}
                                                    <div className='text-danger'>{this.state.errors.repair_remarks}</div>
                                                </div>
                                            </div>
                                            <div className="form-group px-3 pt-3 mb-0">
                                                <div className="d-flex">
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="replace_check"
                                                            name="replace_check"
                                                            checked={this.state.replace_check}
                                                            onChange={e => this.handleChange(e, 'replace_check')}
                                                            style={{width: '20px', height: '20px'}}
                                                        />
                                                    </div>
                                                    <p className="p-0 ml-2 mb-2">Replace</p>
                                                </div>
                                                <div>
                                                    <TextField
                                                        className="textarea-no-padding textarea-font-small"
                                                        variant="outlined"
                                                        color="primary"
                                                        type="text"
                                                        id="replace_remarks"
                                                        name="replace_remarks"
                                                        onChange={(e) => this.handleChange(e, 'replace_remarks')}
                                                        placeholder="Replace remarks"
                                                        value={this.state.replace_remarks}
                                                        fullWidth
                                                        multiline
                                                        minRows={5}
                                                        maxRows={7}
                                                    />
                                                    {validatorSummaryOfCost.message('replace_remarks', this.state.replace_remarks, 'max:3000')}
                                                    <div className='text-danger'>{this.state.errors.replace_remarks}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-detail">
                                            <h3 className="pl-3">Other Summary</h3>
                                            <div className="form-group px-3 pt-3 mb-0">
                                                <div className="d-flex">
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="allegation_check"
                                                            name="allegation_check"
                                                            checked={this.state.allegation_check}
                                                            onChange={e => this.handleChange(e, 'allegation_check')}
                                                            style={{width: '20px', height: '20px'}}
                                                        />
                                                    </div>
                                                    <p className="p-0 ml-2 mb-2">Allegation</p>
                                                </div>
                                                <div>
                                                    <TextField
                                                        className="textarea-no-padding textarea-font-small"
                                                        variant="outlined"
                                                        color="primary"
                                                        type="text"
                                                        id="allegation_remarks"
                                                        name="allegation_remarks"
                                                        onChange={(e) => this.handleChange(e, 'allegation_remarks')}
                                                        placeholder="Allegation remarks"
                                                        value={this.state.allegation_remarks}
                                                        fullWidth
                                                        multiline
                                                        minRows={5}
                                                        maxRows={7}
                                                    />
                                                    {validatorSummaryOfCost.message('allegation_remarks', this.state.allegation_remarks, 'max:3000')}
                                                    <div className='text-danger'>{this.state.errors.allegation_remarks}</div>
                                                </div>
                                            </div>
                                            <div className="form-group px-3 pt-3 mb-0">
                                                <div className="d-flex">
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="claim_document_check"
                                                            name="claim_document_check"
                                                            checked={this.state.claim_document_check}
                                                            onChange={e => this.handleChange(e, 'claim_document_check')}
                                                            style={{width: '20px', height: '20px'}}
                                                        />
                                                    </div>
                                                    <p className="p-0 ml-2 mb-2">Claim Document</p>
                                                </div>
                                                <div>
                                                    <TextField
                                                        className="textarea-no-padding textarea-font-small"
                                                        variant="outlined"
                                                        color="primary"
                                                        type="text"
                                                        id="claim_document_remarks"
                                                        name="claim_document_remarks"
                                                        onChange={(e) => this.handleChange(e, 'claim_document_remarks')}
                                                        placeholder="Claim document remarks"
                                                        value={this.state.claim_document_remarks}
                                                        fullWidth
                                                        multiline
                                                        minRows={5}
                                                        maxRows={7}
                                                    />
                                                    {validatorSummaryOfCost.message('claim_document_remarks', this.state.claim_document_remarks, 'max:3000')}
                                                    <div className='text-danger'>{this.state.errors.claim_document_remarks}</div>
                                                </div>
                                            </div>
                                            <div className="form-group px-3 pt-3 mb-0">
                                                <div className="d-flex">
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            id="warranty_check"
                                                            name="warranty_check"
                                                            checked={this.state.warranty_check}
                                                            onChange={e => this.handleChange(e, 'warranty_check')}
                                                            style={{width: '20px', height: '20px'}}
                                                        />
                                                    </div>
                                                    <p className="p-0 ml-2 mb-2">Warranty</p>
                                                </div>
                                                <div>
                                                    <TextField
                                                        className="textarea-no-padding textarea-font-small"
                                                        variant="outlined"
                                                        color="primary"
                                                        type="text"
                                                        id="warranty_remarks"
                                                        name="warranty_remarks"
                                                        onChange={(e) => this.handleChange(e, 'warranty_remarks')}
                                                        placeholder="Warranty remarks"
                                                        value={this.state.warranty_remarks}
                                                        fullWidth
                                                        multiline
                                                        minRows={5}
                                                        maxRows={7}
                                                    />
                                                    {validatorSummaryOfCost.message('warranty_remarks', this.state.warranty_remarks, 'max:3000')}
                                                    <div className='text-danger'>{this.state.errors.warranty_remarks}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className="full"
                                            onClick={this.handleSubmitSummaryOfCost}
                                            disabled={this.state.loadingSummaryOfCost}
                                        >
                                            Update {this.state.loadingSummaryOfCost && <i className="fa fa-spinner fa-spin"> </i>}
                                        </Button>
                                    </div> */}

                                    {/* Status */}
                                    <div className='table-wrapper detail mb-4'>
                                        <h2 className='title-wrap'>Status {}</h2>
                                        {
                                            this.state.type === 'Report' &&
                                            <div className='card-detail'>
                                                <h3>Survey Status</h3>

                                                {
                                                    this.state.editSurvey ?
                                                        <div>
                                                            {/* <small>{moment(this.state.date_survey_status).format('YYYY/MM/DD')}</small>*/}
                                                            <form>
                                                                <TextField variant='outlined'
                                                                           select
                                                                           id='survey_status_id'
                                                                           name='survey_status_id'
                                                                           label='Survey status'
                                                                           onChange={(e) => this.handleChange(e, 'survey_status_id')}
                                                                           value={this.state.survey_status_id}
                                                                           fullWidth
                                                                >
                                                                    {this.state.survey_status.map(option => (
                                                                        <MenuItem key={option.id} value={option.id}>
                                                                            {option.name}
                                                                        </MenuItem>
                                                                    ))}
                                                                </TextField>
                                                                {validatorSurvey.message('survey_status_id', this.state.survey_status_id, 'required')}
                                                                <div className='text-danger mb-2'>{this.state.errors?.survey_status_id}</div>
                                                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                                                    <DatePicker
                                                                        label="Date of Survey"
                                                                        value={this.state.date_survey_status}
                                                                        onChange={(date) => this.handleDate(date, 'date_survey_status')}
                                                                        format={'dddd, MMMM DD YYYY'}
                                                                        cancelLabel="BATAL"
                                                                        inputVariant="outlined"
                                                                        fullWidth
                                                                    />
                                                                </MuiPickersUtilsProvider>
                                                                <div className='text-danger mb-2'>{this.state.errors?.date_status}</div>
                                                                <TextField variant='outlined'
                                                                           type='text'
                                                                           id='survey_comment'
                                                                           name='survey_comment'
                                                                           label='Place of Survey'
                                                                           onChange={(e) => this.handleChange(e, 'survey_comment')}
                                                                           value={this.state.survey_comment}
                                                                           fullWidth
                                                                />
                                                                <div className='text-danger mb-2'>{this.state.errors?.survey_comment}</div>
                                                                <TextField 
                                                                    variant='outlined'
                                                                    type='text'
                                                                    id='survey_remarks'
                                                                    name='survey_remarks'
                                                                    label='Remarks'
                                                                    onChange={(e) => this.handleChange(e, 'survey_remarks')}
                                                                    value={this.state.survey_remarks}
                                                                    fullWidth
                                                                />
                                                                <div className='text-danger'>{this.state.errors?.survey_remarks}</div>
                                                                <div className="d-flex justify-content-center align-items-center">
                                                                    <Button
                                                                        variant='contained'
                                                                        color='primary'
                                                                        className='full out mt-2'
                                                                        onClick={this.handleSubmitStatusSurvey}
                                                                        disabled={this.state.loadingSurvey }
                                                                    >
                                                                        Save Status{ this.state.loadingSurvey && <i className='fa fa-spinner fa-spin'> </i> }
                                                                    </Button>
                                                                    <Button
                                                                        variant="contained"
                                                                        className="button-cancel full mt-2"
                                                                        onClick={this.handleCancelEditStatusSurvey}
                                                                    >
                                                                        Cancel
                                                                    </Button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                        :
                                                        this.state.loading ?
                                                            <div>
                                                                <Skeleton variant='text' className='mb-3' />
                                                            </div>:
                                                            <div>
                                                                <p>Survey status : <strong>{this.state.survey_status_name}</strong></p>
                                                                <p>Date of Survey : <strong>{this.state.date_survey_status ? moment(this.state.date_survey_status).format('DD MMM YYYY') : ''}</strong></p>
                                                                <p>Place of Survey : <strong>{this.state.survey_comment}</strong></p>
                                                                <p>Remarks : <strong>{this.state.survey_remarks}</strong></p>
                                                                <Button
                                                                    variant='contained'
                                                                    color='primary'
                                                                    className='full mt-3'
                                                                    onClick={this.handleEditStatusSurvey}
                                                                    disabled={this.state.loadingSurvey}
                                                                >
                                                                    Change Status{ this.state.loadingSurvey && <i className='fa fa-spinner fa-spin'> </i> }
                                                                </Button>
                                                            </div>
                                                }

                                            </div>
                                        }
                                        {
                                            this.state.project_survey_status &&
                                            (this.state.type === 'Report' && this.state.project_survey_status.project_status === 'On Progress') &&
                                            (
                                                <div className='card-detail'>
                                                    <h3>{this.state.type} Status</h3>
                                                    {
                                                        this.state.editStatus ?
                                                            <div>
                                                                <form>
                                                                    {
                                                                        this.state.type === 'Report' ?
                                                                            <TextField variant='outlined'
                                                                                    select
                                                                                    id='project_status_id'
                                                                                    name='project_status_id'
                                                                                    label='Report status:'
                                                                                    onChange={(e) => this.handleChange(e, 'project_status_id')}
                                                                                    value={this.state.project_status_id}
                                                                                    fullWidth
                                                                            >
                                                                                {this.state.report_status.map(option => (
                                                                                    <MenuItem key={option.id} value={option.id}>
                                                                                        {option.name}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </TextField>
                                                                            :
                                                                            this.state.type === 'Approval' &&
                                                                            <TextField variant='outlined'
                                                                                    select
                                                                                    id='project_status_id'
                                                                                    name='project_status_id'
                                                                                    label='Approval status'
                                                                                    onChange={(e) => this.handleChange(e, 'project_status_id')}
                                                                                    value={this.state.project_status_id}
                                                                                    fullWidth
                                                                            >
                                                                                {this.state.approval_status.map(option => (
                                                                                    <MenuItem key={option.id} value={option.id}>
                                                                                        {option.name}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </TextField>
                                                                    }
                                                                    {validatorProject.message('project_status_id', this.state.project_status_id, 'required')}
                                                                    <div className='text-danger mb-2'>{this.state.errors?.project_status_id}</div>
                                                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                                                        <DatePicker
                                                                            label="Date of Execute/Issued"
                                                                            value={this.state.date_status}
                                                                            onChange={(date) => this.handleDate(date, 'date_status')}
                                                                            format={'dddd, MMMM DD YYYY'}
                                                                            cancelLabel="BATAL"
                                                                            inputVariant="outlined"
                                                                            fullWidth
                                                                        />
                                                                    </MuiPickersUtilsProvider>
                                                                    <div className='text-danger mb-2'>{this.state.errors?.date_status}</div>
                                                                    <TextField variant='outlined'
                                                                            type='text'
                                                                            id='comment'
                                                                            name='comment'
                                                                            label='Remarks'
                                                                            onChange={(e) => this.handleChange(e, 'comment')}
                                                                            value={this.state.comment}
                                                                            fullWidth
                                                                    />
                                                                    <div className='text-danger'>{this.state.errors?.comment}</div>
                                                                    <div>
                                                                        <div className="d-flex justify-content-center align-items-center">
                                                                            <Button
                                                                                variant='contained'
                                                                                color='primary'
                                                                                className='full out mt-2'
                                                                                onClick={this.handleSubmitStatus}
                                                                                disabled={this.state.loadingProject}
                                                                            >
                                                                                Save Status{ this.state.loadingProject && <i className='fa fa-spinner fa-spin'> </i> }
                                                                            </Button>
                                                                            <Button
                                                                                variant="contained"
                                                                                className="button-cancel full mt-2"
                                                                                onClick={this.handleCancelEditStatus}
                                                                            >
                                                                                Cancel
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                            :
                                                            this.state.loading ?
                                                                <div>
                                                                    <Skeleton variant='text' className='mb-3' />
                                                                </div> :
                                                                <div>
                                                                    <p>{this.state.type} status: <strong>{this.state.project_status_name}</strong></p>
                                                                    <p>Date Execute/Issued: <strong>{this.state.date_status ? moment(this.state.date_status).format('DD MMM YYYY') : null}</strong></p>
                                                                    <p>Remarks: <strong>{this.state.comment}</strong></p>
                                                                    <Button
                                                                        variant='contained'
                                                                        color='primary'
                                                                        className='full mt-3'
                                                                        onClick={this.handleEditStatus}
                                                                        disabled={this.state.loadingProject }
                                                                    >
                                                                        Change Status{ this.state.loadingProject && <i className='fa fa-spinner fa-spin'> </i> }
                                                                    </Button>
                                                                </div>
                                                    }
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.type === 'Approval' &&
                                            <div className='card-detail'>
                                                <h3>{this.state.type} Status</h3>
                                                {
                                                    this.state.editStatus ?
                                                        <div>
                                                            <form>
                                                                {
                                                                    this.state.type === 'Report' ?
                                                                        <TextField variant='outlined'
                                                                                   select
                                                                                   id='project_status_id'
                                                                                   name='project_status_id'
                                                                                   label='Report status:'
                                                                                   onChange={(e) => this.handleChange(e, 'project_status_id')}
                                                                                   value={this.state.project_status_id}
                                                                                   fullWidth
                                                                        >
                                                                            {this.state.report_status.map(option => (
                                                                                <MenuItem key={option.id} value={option.id}>
                                                                                    {option.name}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </TextField>
                                                                        :
                                                                        this.state.type === 'Approval' &&
                                                                        <TextField variant='outlined'
                                                                                   select
                                                                                   id='project_status_id'
                                                                                   name='project_status_id'
                                                                                   label='Approval status'
                                                                                   onChange={(e) => this.handleChange(e, 'project_status_id')}
                                                                                   value={this.state.project_status_id}
                                                                                   fullWidth
                                                                        >
                                                                            {this.state.approval_status.map(option => (
                                                                                <MenuItem key={option.id} value={option.id}>
                                                                                    {option.name}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </TextField>
                                                                }
                                                                {validatorProject.message('project_status_id', this.state.project_status_id, 'required')}
                                                                <div className='text-danger mb-2'>{this.state.errors?.project_status_id}</div>
                                                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                                                    <DatePicker
                                                                        label="Date of Execute/Issued"
                                                                        value={this.state.date_status}
                                                                        onChange={(date) => this.handleDate(date, 'date_status')}
                                                                        format={'dddd, MMMM DD YYYY'}
                                                                        cancelLabel="BATAL"
                                                                        inputVariant="outlined"
                                                                        fullWidth
                                                                    />
                                                                </MuiPickersUtilsProvider>
                                                                <div className='text-danger mb-2'>{this.state.errors?.date_status}</div>
                                                                <TextField variant='outlined'
                                                                           type='text'
                                                                           id='comment'
                                                                           name='comment'
                                                                           label='Remarks'
                                                                           onChange={(e) => this.handleChange(e, 'comment')}
                                                                           value={this.state.comment}
                                                                           fullWidth
                                                                />
                                                                <div className='text-danger'>{this.state.errors?.comment}</div>
                                                                <div>
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <Button
                                                                            variant='contained'
                                                                            color='primary'
                                                                            className='full out mt-2'
                                                                            onClick={this.handleSubmitStatus}
                                                                            disabled={this.state.loadingProject}
                                                                        >
                                                                            Save Status{ this.state.loadingProject && <i className='fa fa-spinner fa-spin'> </i> }
                                                                        </Button>
                                                                        <Button
                                                                            variant="contained"
                                                                            className="button-cancel full mt-2"
                                                                            onClick={this.handleCancelEditStatus}
                                                                        >
                                                                            Cancel
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>
                                                        :
                                                        this.state.loading ?
                                                            <div>
                                                                <Skeleton variant='text' className='mb-3' />
                                                            </div> :
                                                            <div>
                                                                <p>{this.state.type} status: <strong>{this.state.project_status_name}</strong></p>
                                                                <p>Date Execute/Issued: <strong>{this.state.date_status ? moment(this.state.date_status).format('DD MMM YYYY') : null}</strong></p>
                                                                <p>Remarks: <strong>{this.state.comment}</strong></p>
                                                                <Button
                                                                    variant='contained'
                                                                    color='primary'
                                                                    className='full mt-3'
                                                                    onClick={this.handleEditStatus}
                                                                    disabled={this.state.loadingProject }
                                                                >
                                                                    Change Status{ this.state.loadingProject && <i className='fa fa-spinner fa-spin'> </i> }
                                                                </Button>
                                                            </div>

                                                }
                                            </div>
                                        }

                                        {/* <div className='card-detail'>
                                            <h3>Case Status</h3>
                                            {this.state.editStatusCase ? (
                                                <div>
                                                    <form>
                                                        <TextField 
                                                            variant='outlined'
                                                            id='case_status_id'
                                                            name='case_status_id'
                                                            label='Case status: '
                                                            onChange={(e) => this.handleChange(e, 'case_status_id')}
                                                            value={this.state.case_status_id}
                                                            select
                                                            fullWidth
                                                        >
                                                            {this.state.case_status.map(option => (<MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>))}
                                                        </TextField>
                                                        {validatorProject.message('case_status_id', this.state.case_status_id, 'required')}
                                                        <div className='text-danger mb-2'>{this.state.errors?.case_status_id}</div>
                                                        <div>
                                                            <div className="d-flex justify-content-center align-items-center" style={{ gap: '4px' }}>
                                                                <Button
                                                                    variant='contained'
                                                                    color='primary'
                                                                    className='full out mt-2'
                                                                    onClick={this.handleSubmitStatusCase}
                                                                    disabled={this.state.loadingCase}
                                                                >
                                                                    Save Status{ this.state.loadingCase && <i className='fa fa-spinner fa-spin'> </i> }
                                                                </Button>
                                                                <Button
                                                                    variant='contained'
                                                                    color='secondary'
                                                                    className="reject full mt-2"
                                                                    style={{ fontSize: '13px', padding: '5px' }}
                                                                    onClick={this.handleClearCaseStatus}
                                                                >
                                                                    Clear Status{ this.state.loadingCase && <i className='fa fa-spinner fa-spin'> </i> }
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    className="button-cancel full mt-2 ml-0"
                                                                    onClick={this.handleCancelEditStatusCase}
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            ) : (
                                                this.state.loading ? (<div><Skeleton variant='text' className='mb-3' /></div>) :
                                                (
                                                    <div>
                                                        <p>Case status : <strong>{this.state.case_status_name || '-'}</strong></p>
                                                        <Button
                                                            variant='contained'
                                                            color='primary'
                                                            className='full mt-3'
                                                            onClick={this.handleEditStatusCase}
                                                            disabled={this.state.loadingCase}
                                                        >
                                                            Change Status{ this.state.loadingCase && <i className='fa fa-spinner fa-spin'> </i> }
                                                        </Button>
                                                    </div>
                                                )
                                            )}
                                        </div> */}
                                    </div>

                                    {/* Project Summary */}
                                    <div className='table-wrapper detail mb-4'>
                                        <div className="card-detail">
                                            <h3 className="pl-3">Project Summary</h3>
                                            <div className="form-group px-3">
                                                <label>Summary of this Project</label>
                                                <TextField
                                                    className="textarea-no-padding textarea-font-small"
                                                    variant="outlined"
                                                    color="primary"
                                                    type='text'
                                                    id='project_summary'
                                                    name="project_summary"
                                                    onChange={(e) => this.handleChange(e, 'project_summary')}
                                                    value={this.state.project_summary}
                                                    fullWidth
                                                    multiline
                                                    minRows={7}
                                                    maxRows={10}
                                                />
                                                {validatorProjectSummary.message('project_summary', this.state.project_summary, 'max:3000')}
                                                <div className='text-danger'>{this.state.errors.project_summary}</div>
                                            </div>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                className="full"
                                                onClick={this.handleSubmitProjectSummary}
                                                disabled={this.state.loadingProjectSummary}
                                            >
                                                Update{ this.state.loadingProjectSummary && <i className="fa fa-spinner fa-spin"> </i> }
                                            </Button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* Project Comment */}
                        {
                            this.filterPermission('list-comments') &&
                            <div className='col-md-4 mt-3 comment-wrap'>
                                <h3>Comment</h3>

                                <div className='comment-container'>
                                    { this.state.loadingCommentList ?
                                        <div className='row mb-2'>
                                            <div className='col img-avatar'>
                                                <Skeleton variant='circle' width={60} height={60} />
                                            </div>
                                            <div className='col'>
                                                <Skeleton variant='text' />
                                                <Skeleton variant='text' />
                                            </div>
                                        </div> :
                                        this.state.comment_list.length === 0 ?
                                            <div className='col img-avatar mb-2'>
                                                <p>no comment</p>
                                            </div>
                                            :
                                            this.state.comment_list.map(row => (
                                                <div className='row mb-2 position-relative' key={row.id}>
                                                    <div className='col img-avatar'>
                                                        <img src={row.user ? row.user.avatar !== null ? process.env.REACT_APP_API_STORAGE_PATH+row.user.avatar : user : user} alt='avatar' className='img-fluid' />
                                                    </div>
                                                    <div className='col'>
                                                        <h4>{row.user ? row.user.name : ''}</h4>
                                                        <p>{row.comment}</p>
                                                        {row.image &&
                                                        <img
                                                            src={process.env.REACT_APP_API_STORAGE_PATH + row.image}
                                                            alt='avatar' className='img-fluid'/>
                                                        }
                                                        <time>{moment(row.created_at).format('DD/MM/YYYY HH:mm:ss')}</time>
                                                    </div>
                                                    <button className="btn-icon project-detail" onClick={() => this.handleOpenDeleteComment(row, 'project')}>
                                                        <i className="fas fa-trash-alt"> </i>
                                                    </button>
                                                </div>
                                            ))
                                    }
                                </div>

                                {this.state.photo &&
                                <img src={this.state.photo} alt="user" className="photo-image mr-2" />
                                }

                                <input
                                    type="file"
                                    id='image'
                                    name="image"
                                    className="image"
                                    onChange={this.handleAvatar}
                                />
                                {
                                    this.filterPermission('create-comments') &&
                                    <form>
                                        <input
                                            name='user_comment'
                                            onChange={(e) => this.handleChange(e, 'user_comment')}
                                            value={this.state.user_comment}
                                            placeholder='Enter your message'
                                        />
                                        <label htmlFor="image" className="label-file btn btn-upload">
                                            <i className="fas fa-camera-retro"> </i>
                                        </label>
                                        <button onClick={this.handleComment} >
                                            { this.state.loadingComment ? <i className='fa fa-spinner fa-spin'> </i>
                                                : <SendIcon />
                                            }
                                        </button>
                                    </form>
                                }

                                {validatorComment.message('user_comment', this.state.user_comment, 'required')}
                                <div className='text-danger mb-2'>{this.state.errors?.user_comment}</div>
                                {/* END Project Comment */}

                                <div className="card-cancel mt-4">
                                    {this.state.top_project_status === 'Cancel' ?
                                    <>
                                        <h3>REVERT CANCELED PROJECT</h3>
                                        <p>PROJECT STATUS MENJADI KEMBALI</p>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            className="reject full mb-4"
                                            onClick={() => this.handleOpenRevert()}
                                            disabled={this.state.loadingButton }
                                        >
                                            Revert Project{ this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i> }
                                        </Button>
                                    </> :
                                        <>
                                            <h3>CANCEL PROJECT</h3>
                                            <p>PROJECT STATUS MENJADI CANCEL</p>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                className="reject full mb-4"
                                                onClick={() => this.handleOpen()}
                                                disabled={this.state.loadingButton }
                                            >
                                                Cancel Project{ this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i> }
                                            </Button>
                                        </>
                                    }

                                    <h3>DELETE PROJECT</h3>
                                    <p>PROJECT STATUS MENGHILANG DARI SISTEM</p>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        className="reject full"
                                        onClick={() => this.handleOpenDelete()}
                                        disabled={this.state.loadingButton }
                                    >
                                        Delete Project{ this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i> }
                                    </Button>
                                    <img src={cancel} alt='project' className="img-fluid" />
                                </div>

                                {/* Comment Client */}
                                <h3 className='mt-4'>Comment Client</h3>
                                <div className='comment-container'>
                                    { this.state.loadingCommentListClient ?
                                        <div className='row mb-2'>
                                            <div className='col img-avatar'>
                                                <Skeleton variant='circle' width={60} height={60} />
                                            </div>
                                            <div className='col'>
                                                <Skeleton variant='text' />
                                                <Skeleton variant='text' />
                                            </div>
                                        </div> :
                                        this.state.comment_list_client.length === 0 ?
                                            <div className='col img-avatar mb-2'>
                                                <p>no comment</p>
                                            </div>
                                            :
                                            this.state.comment_list_client.map(row => (
                                                <div className='row mb-2 position-relative' key={row.id}>
                                                    <div className='col img-avatar'>
                                                        <img src={row.user ? row.user.avatar !== null ? process.env.REACT_APP_API_STORAGE_PATH+row.user.avatar : user : user} alt='avatar' className='img-fluid' />
                                                    </div>
                                                    <div className='col'>
                                                        <h4>{row.user ? row.user.name : ''} {row.client ? row.client.name : ''}</h4>
                                                        <p>{row.comment}</p>
                                                        {/*{row.image &&*/}
                                                        {/*<img*/}
                                                        {/*    src={process.env.REACT_APP_API_STORAGE_PATH + row.image}*/}
                                                        {/*    alt='avatar' className='img-fluid'/>*/}
                                                        {/*}*/}
                                                        <time>{moment(row.created_at).format('DD/MM/YYYY HH:mm:ss')}</time>
                                                    </div>
                                                    <button className="btn-icon project-detail" onClick={() => this.handleOpenDeleteComment(row, 'client')}>
                                                        <i className="fas fa-trash-alt"> </i>
                                                    </button>
                                                </div>
                                            ))
                                    }
                                </div>

                                {this.state.photo &&
                                <img src={this.state.photo} alt="client" className="photo-image mr-2" />
                                }

                                <input
                                    type="file"
                                    id='image'
                                    name="image"
                                    className="image"
                                    onChange={this.handleAvatar}
                                />
                                {
                                    this.filterPermission('create-comments') &&
                                    <form>
                                        <input
                                            name='client_comment'
                                            onChange={(e) => this.handleChange(e, 'client_comment')}
                                            value={this.state.client_comment}
                                            placeholder='Enter your message'
                                        />
                                        <button onClick={this.handleCommentClient} >
                                            { this.state.loadingComment ? <i className='fa fa-spinner fa-spin'> </i>
                                                : <SendIcon />
                                            }
                                        </button>
                                    </form>
                                }

                                {validatorCommentClient.message('client_comment', this.state.client_comment, 'required')}
                                <div className='text-danger mb-2'>{this.state.errors?.client_comment}</div>
                                {/*END - Comment Client */}


                            </div>
                        }
                    </div>
                </div>

                <div className='col-12 pl-lg-5'>
                    <div className='table-wrapper detail table-exp mb-4'>

                        {/* Multiple Case Survey Status */}
                        <div className='card-detail'>
                            <h3>Survey Status</h3>
                            <div className='row align-items-center mb-3 mx-0 px-2'>
                                <div className='col-md-6'>
                                    <h2 className='title-wrap mb-0'> Survey Status List</h2>
                                </div>
                                <div className='col-md-6 text-right'>
                                    <Button
                                        variant='contained'
                                        color='secondary'
                                        className='mr-2'
                                        onClick={(e) => this.handleAddNewMultipleCaseSurveyStatus()}
                                    >
                                        New Survey Status
                                    </Button>
                                </div>
                            </div>
                            <div className='row head-form px-4'>
                                <div className='col-12 col-xl-1'><strong>Action</strong></div>
                                <div className='col-12 col-xl d-none d-xl-block'><strong>Survey Status</strong></div>
                                <div className='col-12 col-xl d-none d-xl-block'><strong>Notes</strong></div>
                            </div>
                            {
                                this.state.case_survey_status_multiple.length > 0 ?
                                this.state.case_survey_status_multiple.map(function (item, idx) {
                                    return <div className='row align-items-center px-4' key={idx}>
                                        <div className='col-6 col-md-4 col-xl-1 text-center'>
                                            <button className='btn-icon' onClick={(e) => this.handleDeleteMultipleCaseSurveyStatus(idx)}>
                                                <i className='fas fa-trash-alt'> </i>
                                            </button>
                                        </div>
                                        <div className='col-6 col-md-4 col-xl'>
                                            <div className='form-group'>
                                                <TextField
                                                    variant='outlined'
                                                    type='text'
                                                    id={'case_survey_status_master_'+idx}
                                                    name={'case_survey_status_id_'+idx}
                                                    onChange={(e) => this.handleChangeMultipleCaseSurveyStatus(e, 'case_survey_status_id', idx)}
                                                    label='Survey Status'
                                                    value={item.case_survey_status_id || ''}
                                                    fullWidth
                                                    select
                                                >
                                                    {this.state.lifecycle_case_survey_status_master.map(option => (
                                                        <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                                                    ))}
                                                </TextField>
                                                {validatorEx.message('case_survey_status_id-'+idx, item.case_survey_status_id, 'required')}
                                                <div className='text-danger'>{this.state.errors?.['case_survey_status_id-'+idx]}</div>
                                            </div>
                                        </div>
                                        <div className='col-6 col-md-4 col-xl'>
                                            <div className='form-group'>
                                                <TextField
                                                    variant='outlined'
                                                    type='text'
                                                    id={'case_survey_status_notes-'+idx}
                                                    name={'case_survey_status_notes-'+idx}
                                                    label='Notes'
                                                    onChange={(e) => this.handleChangeMultipleCaseSurveyStatus(e, 'notes', idx)}
                                                    value={item.notes ? item.notes : ''}
                                                    fullWidth
                                                />
                                                <div className='text-danger'>{this.state.errors?.['case_survey_notes-'+idx]}</div>
                                            </div>
                                        </div>

                                    </div>
                                }.bind(this))
                                :
                                <div className='row align-items-center text-center px-4'><div className='col-12'><p>No data available</p></div></div>
                            }
                            <div className='row align-items-center mt-2 mx-0 px-2'>
                                <div className='col-md-6'>
                                </div>
                                <div className='col-md-6 text-right'>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        className='mr-2'
                                        style={{ padding: '10px 25px' }}
                                        onClick={(e) => this.handleSaveMultipleCaseSurveyStatus(e)}
                                        disabled={this.state.loadingCaseSurveyStatusMultiple}
                                    >
                                        Update Survey Status{ this.state.loadingCaseSurveyStatusMultiple && <i className='fa fa-spinner fa-spin'> </i> }
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {/* Multiple Case Status */}
                        <div className='card-detail'>
                            <h3>Case Status</h3>
                            <div className='row align-items-center mb-3 mx-0 px-2'>
                                <div className='col-md-6'>
                                    <h2 className='title-wrap mb-0'> Case Status List</h2>
                                </div>
                                <div className='col-md-6 text-right'>
                                    <Button
                                        variant='contained'
                                        color='secondary'
                                        className='mr-2'
                                        onClick={(e) => this.handleAddNewMultipleCaseStatus()}
                                    >
                                        New Case Status
                                    </Button>
                                </div>
                            </div>
                            <div className='row head-form px-4'>
                                <div className='col-12 col-xl-1'><strong>Action</strong></div>
                                <div className='col-12 col-xl d-none d-xl-block'><strong>Case Status</strong></div>
                                <div className='col-12 col-xl d-none d-xl-block'><strong>Notes</strong></div>
                            </div>
                            {
                                this.state.case_status_multiple.length > 0 ?
                                this.state.case_status_multiple.map(function (item, idx) {
                                    return <div className='row align-items-center px-4' key={idx}>
                                        <div className='col-6 col-md-4 col-xl-1 text-center'>
                                            <button className={'btn-icon' + (item.type === 'red' ? ' green' : '')} onClick={(e) => this.handleDeleteMultipleCaseStatus(idx)}>
                                                <i className='fas fa-trash-alt'> </i>
                                            </button>
                                        </div>
                                        <div className='col-6 col-md-4 col-xl'>
                                            <div className='form-group'>
                                                <TextField 
                                                    variant='outlined'
                                                    type='text'
                                                    id={'case_status_master_'+idx}
                                                    name={'cases_status_id_'+idx}
                                                    onChange={(e) => this.handleChangeMultipleCaseStatus(e, 'cases_status_id', idx)}
                                                    label='Case Status'
                                                    value={item.cases_status_id || ''}
                                                    fullWidth
                                                    select
                                                >
                                                    {this.state.case_status.map(option => (
                                                        <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                                                    ))}
                                                </TextField>
                                                {validatorEx.message('cases_status_id-'+idx, item.cases_status_id, 'required')}
                                                <div className='text-danger'>{this.state.errors?.['cases_status_id-'+idx]}</div>
                                            </div>
                                        </div>
                                        <div className='col-6 col-md-4 col-xl'>
                                            <div className='form-group'>
                                                <TextField
                                                    variant='outlined'
                                                    type='text'
                                                    id={'case_status_notes-'+idx}
                                                    name={'case_status_notes-'+idx}
                                                    label='Notes'
                                                    onChange={(e) => this.handleChangeMultipleCaseStatus(e, 'notes', idx)}
                                                    value={item.notes ? item.notes : ''}
                                                    fullWidth
                                                />
                                                <div className='text-danger'>{this.state.errors?.['notes-'+idx]}</div>
                                            </div>
                                        </div>

                                    </div>
                                }.bind(this))
                                :
                                <div className='row align-items-center text-center px-4'><div className='col-12'><p>No data available</p></div></div>
                            }
                            <div className='row align-items-center mt-2 mx-0 px-2'>
                                <div className='col-md-6'>
                                </div>
                                <div className='col-md-6 text-right'>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        className='mr-2'
                                        style={{ padding: '10px 25px' }}
                                        onClick={(e) => this.handleSaveMultipleCaseStatus(e)}
                                        disabled={this.state.loadingCaseStatusMultiple}
                                    >
                                        Update Case Status{ this.state.loadingCaseStatusMultiple && <i className='fa fa-spinner fa-spin'> </i> }
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {/* Multiple Approval Status */}
                        <div className='card-detail'>
                            <h3>Approval Status</h3>
                            <div className='row align-items-center mb-3 mx-0 px-2'>
                                <div className='col-md-6'>
                                    <h2 className='title-wrap mb-0'> Approval Status List</h2>
                                </div>
                                <div className='col-md-6 text-right'>
                                    <Button
                                        variant='contained'
                                        color='secondary'
                                        className='mr-2'
                                        onClick={this.handleAddNewMultipleApprovalStatus}
                                    >
                                        New Approval Status
                                    </Button>
                                </div>
                            </div>

                            <div className='row head-form px-4'>
                                <div className='col-12 col-xl-1'><strong>Action</strong></div>
                                <div className='col-12 col-xl d-none d-xl-block'><strong>Approval Status</strong></div>
                                <div className='col-12 col-xl d-none d-xl-block'><strong>Remarks</strong></div>
                            </div>

                            {
                                this.state.approval_status_multiple.length > 0 ?
                                this.state.approval_status_multiple.map(function (item, idx) {
                                    return <div className='row align-items-center px-4' key={idx}>
                                        <div className='col-6 col-md-4 col-xl-1 text-center'>
                                            <button className='btn-icon' onClick={(e) => this.handleDeleteMultipleApprovalStatus(idx)}>
                                                <i className='fas fa-trash-alt'> </i>
                                            </button>
                                        </div>
                                        <div className='col-6 col-md-4 col-xl'>
                                            <div className='form-group'>
                                                <TextField
                                                    variant='outlined'
                                                    type='text'
                                                    id={'approval_status_master_' + idx}
                                                    name={'approval_status_id_' + idx}
                                                    onChange={(e) => this.handleChangeMultipleApprovalStatus(e, 'approval_status_id', idx)}
                                                    label='Approval Status'
                                                    value={item.approval_status_id || ''}
                                                    fullWidth
                                                    select
                                                >
                                                    {this.state.lifecycle_approval_status_master.map(option => (
                                                        <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                                                    ))}
                                                </TextField>
                                                {validatorEx.message('approval_status_id-' + idx, item.approval_status_id, 'required')}
                                                <div className='text-danger'>{this.state.errors?.['approval_status_id-' + idx]}</div>
                                            </div>
                                        </div>
                                        <div className='col-6 col-md-4 col-xl'>
                                            <div className='form-group'>
                                                <TextField
                                                    variant='outlined'
                                                    type='text'
                                                    id={'approval_status_remarks-' + idx}
                                                    name={'approval_status_remarks-' + idx}
                                                    label='Remarks'
                                                    onChange={(e) => this.handleChangeMultipleApprovalStatus(e, 'remarks', idx)}
                                                    value={item.remarks ? item.remarks : ''}
                                                    fullWidth
                                                />
                                                <div className='text-danger'>{this.state.errors?.['approval_remarks-' + idx]}</div>
                                            </div>
                                        </div>
                                    </div>
                                }.bind(this))
                                :
                                <div className='row align-items-center text-center px-4'><div className='col-12'><p>No data available</p></div></div>
                            }

                            <div className='row align-items-center mt-2 mx-0 px-2'>
                                <div className='col-md-6'>
                                </div>
                                <div className='col-md-6 text-right'>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        className='mr-2'
                                        style={{ padding: '10px 25px' }}
                                        onClick={(e) => this.handleSaveMultipleApprovalStatus(e)}
                                        disabled={this.state.loadingApprovalStatusMultiple}
                                    >
                                        Update Approval Status
                                        {this.state.loadingApprovalStatusMultiple && <i className="fa fa-spinner fa-spin"> </i>}
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {/* Multiple Summary Of Cost */}
                        <div className='card-detail'>
                            <h3>Summary Of Cost</h3>
                            <div className='row align-items-center mb-3 mx-0 px-2'>
                                <div className='col-md-6'>
                                    <h2 className='title-wrap mb-0'> Summary Of Cost List</h2>
                                </div>
                                <div className='col-md-6 text-right'>
                                    <Button
                                        variant='contained'
                                        color='secondary'
                                        className='mr-2'
                                        onClick={this.handleAddNewMultipleSummaryOfCost}
                                    >
                                        New Summary Of Cost
                                    </Button>
                                </div>
                            </div>

                            <div className='row head-form px-4'>
                                <div className='col-12 col-xl-1'><strong>Action</strong></div>
                                <div className='col-12 col-xl-2 d-none d-xl-block'><strong>Item</strong></div>
                                <div className='col-12 col-xl-2 d-none d-xl-block'><strong>Report Estimation</strong></div>
                                <div className='col-12 col-xl-2 d-none d-xl-block'><strong>Claim From Owner In Approval</strong></div>
                                <div className='col-12 col-xl d-none d-xl-block'><strong>Remarks</strong></div>
                            </div>

                            {
                                this.state.summary_of_cost_multiple.length > 0 ?
                                this.state.summary_of_cost_multiple.map(function (item, idx) {
                                    return <div className='row align-items-center px-4' key={idx}>
                                        <div className='col-6 col-md-4 col-xl-1 text-center'>
                                            <button className='btn-icon' onClick={(e) => this.handleDeleteMultipleSummaryOfCost(idx)}>
                                                <i className='fas fa-trash-alt'> </i>
                                            </button>
                                        </div>
                                        <div className='col-6 col-md-4 col-xl-2'>
                                            <div className='form-group'>
                                                <TextField
                                                    label='Item'
                                                    variant='outlined'
                                                    type='text'
                                                    id={'summary_of_cost_master_' + idx}
                                                    name={'summary_of_cost_id_' + idx}
                                                    onChange={(e) => this.handleChangeMultipleSummaryOfCost(e, 'summary_of_cost_id', idx)}
                                                    value={item.summary_of_cost_id || ''}
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder='Select Item'
                                                    fullWidth
                                                    select
                                                >
                                                    {this.state.summary_of_cost_master.map(option => (
                                                        <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                                                    ))}
                                                </TextField>
                                                {validatorEx.message('summary_of_cost_id-' + idx, item.summary_of_cost_id, 'required')}
                                                <div className='text-danger'>{this.state.errors?.['summary_of_cost_id-' + idx]}</div>
                                            </div>
                                        </div>
                                        <div className='col-6 col-md-4 col-xl-2'>
                                            <div className='form-group'>
                                                <TextField
                                                    label='Report Estimation'
                                                    variant='outlined'
                                                    type='number'
                                                    id={'summary_of_cost_report_estimation_' + idx}
                                                    name={'summary_of_cost_report_estimation_' + idx}
                                                    onChange={(e) => this.handleChangeMultipleSummaryOfCost(e, 'report_estimation', idx)}
                                                    value={item.report_estimation ? item.report_estimation : ''}
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder='0.00'
                                                    fullWidth
                                                />
                                                <div className='text-danger'>{this.state.errors?.['summary_report_estimation-' + idx]}</div>
                                            </div>
                                        </div>
                                        <div className='col-6 col-md-4 col-xl-2'>
                                            <div className='form-group'>
                                                <TextField
                                                    label='Claim From Owner In Approval'
                                                    variant='outlined'
                                                    type='number'
                                                    id={'summary_of_cost_claim_from_owner_in_approval_' + idx}
                                                    name={'summary_of_cost_claim_from_owner_in_approval_' + idx}
                                                    onChange={(e) => this.handleChangeMultipleSummaryOfCost(e, 'claim_from_owner_in_approval', idx)}
                                                    value={item.claim_from_owner_in_approval ? item.claim_from_owner_in_approval : ''}
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder='0.00'
                                                    fullWidth
                                                />
                                                <div className='text-danger'>{this.state.errors?.['summary_claim_from_owner_in_approval-' + idx]}</div>
                                            </div>
                                        </div>
                                        <div className='col-6 col-md-4 col-xl-5'>
                                            <div className='form-group'>
                                                <TextField
                                                    label='Remarks'
                                                    variant='outlined'
                                                    type='text'
                                                    id={'summary_of_cost_remarks_' + idx}
                                                    name={'summary_of_cost_remarks_' + idx}
                                                    onChange={(e) => this.handleChangeMultipleSummaryOfCost(e, 'remarks', idx)}
                                                    value={item.remarks ? item.remarks : ''}
                                                    InputLabelProps={{ shrink: true }}
                                                    placeholder='Remarks'
                                                    fullWidth
                                                />
                                                <div className='text-danger'>{this.state.errors?.['summary_remarks-' + idx]}</div>
                                            </div>
                                        </div>
                                    </div>
                                }.bind(this))
                                :
                                <div className='row align-items-center text-center px-4'><div className='col-12'><p>No data available</p></div></div>
                            }

                            <div className='row align-items-center mt-2 mx-0 px-2'>
                                <div className='col-md-6'>
                                </div>
                                <div className='col-md-6 text-right'>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        className='mr-2'
                                        style={{ padding: '10px 25px' }}
                                        onClick={(e) => this.handleSaveMultipleSummaryOfCost(e)}
                                        disabled={this.state.loadingSummaryOfCostMultiple}
                                    >
                                        Update Summary Of Cost
                                        {this.state.loadingSummaryOfCostMultiple && <i className="fa fa-spinner fa-spin"> </i>}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* DEVNOTE: Temporary Hidden per client request from 22/04/2026 */}
                {/* Project Expenses */}
                {
                    false &&
                    // this.filterPermission('view-expenses') &&
                    <div className='col-12 pl-lg-5'>
                        <div className='table-wrapper detail table-exp'>
                            <h2 className='title-wrap'> Project Expenses</h2>

                            {/* Rate Expenses */}
                            <div className="card-detail">
                                <h3>Rate Expenses</h3>
                                <div className="row colored px-4">
                                    <div className="col-md-6">
                                        <div className='form-group'>
                                            <label>Currency</label>
                                            <TextField 
                                                variant='outlined'
                                                id='currency'
                                                name='currency'
                                                label='Currency'
                                                onChange={(e) => this.handleChange(e, 'currency')}
                                                value={this.state.currency}
                                                fullWidth
                                                select
                                            >
                                                <MenuItem value='IDR'>IDR</MenuItem>
                                                <MenuItem value='USD'>USD</MenuItem>
                                                <MenuItem value='SGD'>SGD</MenuItem>
                                            </TextField>
                                            {validatorRateExpenses.message('currency', this.state.currency, 'required')}
                                            <div className='text-danger'>{this.state.errors.currency}</div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        {this.state.show_fx_rate && (
                                            <div className="form-group">
                                                <label>FX Rate</label>
                                                <TextField 
                                                    variant="outlined"
                                                    type='text'
                                                    id='fx_rate'
                                                    name="fx_rate"
                                                    label="FX Rate"
                                                    onChange={(e) => this.handleChange(e, 'fx_rate')}
                                                    value={this.state.fx_rate}
                                                    InputProps={{ inputComponent: this.NumberFormatCustom }}
                                                    fullWidth
                                                />
                                                {validatorRateExpenses.message('fx_rate', this.state.fx_rate, 'required')}
                                                <div className='text-danger'>{this.state.errors.fx_rate}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Survey Expenses */}
                            <div className='card-detail'>
                                <h3>Survey Expenses</h3>
                                <div className='row align-items-center mb-3 mx-0 px-2'>
                                    <div className='col-md-6'>
                                        <h2 className='title-wrap mb-0'> Survey Expenses List</h2>
                                    </div>
                                    {
                                        this.filterPermission('create-expenses') &&
                                        <div className='col-md-6 text-right'>
                                            <Button
                                                variant='contained'
                                                color='secondary'
                                                className='mr-2'
                                                onClick={(e) => this.handleNewExpense('survey')}
                                            >
                                                New Survey Expense
                                            </Button>
                                            {/* <Button
                                                variant='contained'
                                                color='secondary'
                                                className='mr-2'
                                                onClick={this.handleNewAdvance}
                                            >
                                                Cash Advance
                                            </Button> */}
                                        </div>
                                    }

                                </div>
                                <div className='row head-form px-4'>
                                    <div className='col-12 col-xl-1'><strong>Action</strong></div>
                                    <div className='col-12 col-xl-2 d-none d-xl-block'><strong>Date</strong></div>
                                    <div className='col-12 col-xl-2 d-none d-xl-block'><strong>Description</strong></div>
                                    <div className='col-12 col-xl-2 d-none d-xl-block'><strong>Amount</strong></div>
                                    {this.state.show_fx_rate && <div className='col-12 col-xl-2 d-none d-xl-block'><strong>IDR Amount</strong></div>}
                                    <div className='col-12 col-xl d-none d-xl-block'><strong>Remarks</strong></div>
                                </div>
                                {
                                    this.state.survey_expenses.length > 0 ?
                                    this.state.survey_expenses.map(function (item, idx) {
                                        return <div className='row align-items-center px-4' key={idx}>
                                            <div className='col-6 col-md-4 col-xl-1 text-center'>
                                                <button className={'btn-icon' + (item.type === 'red' ? ' green' : '')} onClick={(e) => this.handleDeleteExpenseSurvey(idx)}>
                                                    <i className='fas fa-trash-alt'> </i>
                                                </button>
                                            </div>
                                            <div className='col-6 col-md-4 col-xl-2'>
                                                <div className='form-group'>
                                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                                        <DatePicker
                                                            id={'survey_exp_date_'+idx}
                                                            label='Date'
                                                            value={item.date}
                                                            onChange={(date) => this.handleChangeExpenseSurvey(date, 'date', idx)}
                                                            format={'ddd, MMMM DD YYYY'}
                                                            cancelLabel='BATAL'
                                                            inputVariant='outlined'
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                    {validatorEx.message('date-'+idx, item.date, 'required')}
                                                    <div className='text-danger'>{this.state.errors?.['date-'+idx]}</div>
                                                </div>
                                            </div>
                                            <div className='col-6 col-md-4 col-xl-2'>
                                                <div className='form-group'>
                                                    <TextField variant='outlined'
                                                            type='text'
                                                            id={'survey_exp_description_'+idx}
                                                            name={'survey_exp_description_'+idx}
                                                            onChange={(e) => this.handleChangeExpenseSurvey(e, 'description', idx)}
                                                            label='Description'
                                                            value={item.description ? item.description : ''}
                                                            fullWidth
                                                    />
                                                    {validatorEx.message('description-'+idx, item.description, 'required')}
                                                    <div className='text-danger'>{this.state.errors?.['description-'+idx]}</div>
                                                </div>
                                            </div>
                                            <div className='col-6 col-md-4 col-xl-2'>
                                                <div className='form-group'>
                                                    <TextField
                                                        variant='outlined'
                                                        type='text'
                                                        id={'survey_exp_amount_'+idx}
                                                        name={'survey_exp_amount_'+idx}
                                                        label='Amount'
                                                        value={item.amount ? item.amount : 0}
                                                        onChange={(e) => this.handleChangeExpenseSurvey(e, 'amount', idx)}
                                                        onBlur={(e) => this.calculateTotalExpenses()}
                                                        InputProps={{ inputComponent: this.NumberFormatCustom }}
                                                        fullWidth
                                                    />
                                                    {validatorEx.message('amount-'+idx, item.amount, 'required')}
                                                    <div className='text-danger'>{this.state.errors?.['amount-'+idx]}</div>
                                                </div>
                                            </div>
                                            {
                                                this.state.show_fx_rate &&
                                                <div className='col-6 col-md-4 col-xl-2'>
                                                    <div className='form-group'>
                                                        <TextField 
                                                            variant='outlined'
                                                            type='text'
                                                            id={'survey_exp_idr_amount_'+idx}
                                                            name={'survey_exp_idr_amount_'+idx}
                                                            label='IDR Amount'
                                                            value={(this.state.fx_rate || 0) * (item.amount || 0)}
                                                            InputProps={{ inputComponent: this.NumberFormatCustom }}
                                                            fullWidth
                                                            disabled
                                                        />
                                                        {validatorEx.message('idr_amount-'+idx, item.idr_amount, 'required')}
                                                        <div className='text-danger'>{this.state.errors?.['idr_amount-'+idx]}</div>
                                                    </div>
                                                </div>
                                            }
                                            <div className='col-6 col-md-4 col-xl'>
                                                <div className='form-group'>
                                                    <TextField
                                                        variant='outlined'
                                                        type='text'
                                                        id={'survey_exp_remarks-'+idx}
                                                        name={'survey_exp_remarks-'+idx}
                                                        label='Remarks'
                                                        onChange={(e) => this.handleChangeExpenseSurvey(e, 'remarks', idx)}
                                                        value={item.remarks ? item.remarks : ''}
                                                        fullWidth
                                                    />
                                                    <div className='text-danger'>{this.state.errors?.['remarks-'+idx]}</div>
                                                </div>
                                            </div>

                                        </div>
                                    }.bind(this))
                                    :
                                    <div className='row align-items-center text-center px-4'><div className='col-12'><p>No data available</p></div></div>
                                }
                            </div>

                            {/* Office Expenses */}
                            <div className='card-detail'>
                                <h3>Office Expenses</h3>
                                <div className='row align-items-center mb-3 mx-0 px-2'>
                                    <div className='col-md-6'>
                                        <h2 className='title-wrap mb-0'> Office Expenses List</h2>
                                    </div>
                                    {
                                        this.filterPermission('create-expenses') &&
                                        <div className='col-md-6 text-right'>
                                            <Button
                                                variant='contained'
                                                color='secondary'
                                                className='mr-2'
                                                onClick={(e) => this.handleNewExpense('office')}
                                            >
                                                New Office Expense
                                            </Button>
                                            {/* <Button
                                                variant='contained'
                                                color='secondary'
                                                className='mr-2'
                                                onClick={this.handleNewAdvance}
                                            >
                                                Cash Advance
                                            </Button> */}
                                        </div>
                                    }

                                </div>
                                <div className='row head-form px-4'>
                                    <div className='col-12 col-xl-1'><strong>Action</strong></div>
                                    <div className='col-12 col-xl-2 d-none d-xl-block'><strong>Date</strong></div>
                                    <div className='col-12 col-xl-2 d-none d-xl-block'><strong>Description</strong></div>
                                    <div className='col-12 col-xl-2 d-none d-xl-block'><strong>Amount</strong></div>
                                    {this.state.show_fx_rate && <div className='col-12 col-xl-2 d-none d-xl-block'><strong>IDR Amount</strong></div>}
                                    <div className='col-12 col-xl d-none d-xl-block'><strong>Remarks</strong></div>
                                </div>
                                {
                                    this.state.office_expenses.length > 0 ?
                                    this.state.office_expenses.map(function (item, idx) {
                                        return <div className='row align-items-center px-4' key={idx}>
                                            <div className='col-6 col-md-4 col-xl-1 text-center'>
                                                <button className={'btn-icon' + (item.type === 'red' ? ' green' : '')} onClick={(e) => this.handleDeleteExpenseOffice(idx)}>
                                                    <i className='fas fa-trash-alt'> </i>
                                                </button>
                                            </div>
                                            <div className='col-6 col-md-4 col-xl-2'>
                                                <div className='form-group'>
                                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                                        <DatePicker
                                                            id={'office_exp_date_'+idx}
                                                            name={'office_exp_date_'+idx}
                                                            label='Date'
                                                            value={item.date}
                                                            onChange={(date) => this.handleChangeExpenseOffice(date, 'date', idx)}
                                                            format={'ddd, MMMM DD YYYY'}
                                                            cancelLabel='BATAL'
                                                            inputVariant='outlined'
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                    {validatorEx.message('date-'+idx, item.date, 'required')}
                                                    <div className='text-danger'>{this.state.errors?.['date-'+idx]}</div>
                                                </div>
                                            </div>
                                            <div className='col-6 col-md-4 col-xl-2'>
                                                <div className='form-group'>
                                                    <TextField 
                                                        variant='outlined'
                                                        type='text'
                                                        id={'office_exp_description_'+idx}
                                                        name={'office_exp_description_'+idx}
                                                        onChange={(e) => this.handleChangeExpenseOffice(e, 'description', idx)}
                                                        label='Description'
                                                        value={item.description ? item.description : ''}
                                                        fullWidth
                                                    />
                                                    {validatorEx.message('description-'+idx, item.description, 'required')}
                                                    <div className='text-danger'>{this.state.errors?.['description-'+idx]}</div>
                                                </div>
                                            </div>
                                            <div className='col-6 col-md-4 col-xl-2'>
                                                <div className='form-group'>
                                                    <TextField 
                                                        variant='outlined'
                                                        type='text'
                                                        id={'office_exp_amount-'+idx}
                                                        name={'office_exp_amount-'+idx}
                                                        label='Amount'
                                                        value={item.amount ? item.amount : 0}
                                                        onChange={(e) => this.handleChangeExpenseOffice(e, 'amount', idx)}
                                                        onBlur={(e) => this.calculateTotalExpenses()}
                                                        InputProps={{ inputComponent: this.NumberFormatCustom }}
                                                        fullWidth
                                                    />
                                                    {validatorEx.message('amount-'+idx, item.amount, 'required')}
                                                    <div className='text-danger'>{this.state.errors?.['amount-'+idx]}</div>
                                                </div>
                                            </div>
                                            {
                                                this.state.show_fx_rate &&
                                                <div className='col-6 col-md-4 col-xl-2'>
                                                    <div className='form-group'>
                                                        <TextField 
                                                            variant='outlined'
                                                            type='text'
                                                            id={'office_exp_idr_amount-'+idx}
                                                            name={'office_exp_idr_amount-'+idx}
                                                            label='IDR Amount'
                                                            value={(this.state.fx_rate || 0) * (item.amount || 0)}
                                                            InputProps={{ inputComponent: this.NumberFormatCustom }}
                                                            fullWidth
                                                            disabled
                                                        />
                                                        {validatorEx.message('idr_amount-'+idx, item.idr_amount, 'required')}
                                                        <div className='text-danger'>{this.state.errors?.['idr_amount-'+idx]}</div>
                                                    </div>
                                                </div>
                                            }
                                            <div className='col-6 col-md-4 col-xl'>
                                                <div className='form-group'>
                                                    <TextField 
                                                        variant='outlined'
                                                        type='text'
                                                        id={'office_exp_remarks-'+idx}
                                                        name={'office_exp_remarks-'+idx}
                                                        label='Remarks'
                                                        onChange={(e) => this.handleChangeExpenseOffice(e, 'remarks', idx)}
                                                        value={item.remarks ? item.remarks : ''}
                                                        fullWidth
                                                    />
                                                    <div className='text-danger'>{this.state.errors?.['remarks-'+idx]}</div>
                                                </div>
                                            </div>

                                        </div>
                                    }.bind(this))
                                    :
                                    <div className='row align-items-center text-center px-4'><div className='col-12'><p>No data available</p></div></div>
                                }
                            </div>

                            {/* Uncategorized Expenses */}
                            <div className='card-detail'>
                                <h3>Uncategorized Expenses</h3>
                                <div className='row align-items-center mb-3 mx-0 px-2'>
                                    <div className='col-md-6'>
                                        <h2 className='title-wrap mb-0'> Uncategorized Expenses List</h2>
                                    </div>
                                </div>
                                <div className='row head-form px-4'>
                                    <div className='col-12 col-xl-1'><strong>Action</strong></div>
                                    <div className='col-12 col-xl-2 d-none d-xl-block'><strong>Date</strong></div>
                                    <div className='col-12 col-xl-2 d-none d-xl-block'><strong>Description</strong></div>
                                    <div className='col-12 col-xl-2 d-none d-xl-block'><strong>Amount</strong></div>
                                    <div className='col-12 col-xl d-none d-xl-block'><strong>Remarks</strong></div>
                                </div>
                                {
                                    this.state.uncategorized_expenses.length > 0 ?
                                    this.state.uncategorized_expenses.map(function (item, idx) {
                                        return <div className='row align-items-center px-4' key={idx}>
                                            <div className='col-6 col-md-4 col-xl-1 text-center'>
                                                <button className={'btn-icon' + (item.type === 'red' ? ' green' : '')} onClick={(e) => this.handleDeleteExpenseUncategorized(idx)}>
                                                    <i className='fas fa-trash-alt'> </i>
                                                </button>
                                            </div>
                                            <div className='col-6 col-md-4 col-xl-2'>
                                                <div className='form-group'>
                                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                                        <DatePicker
                                                            id={'uncategorized_exp_date_'+idx}
                                                            name={'uncategorized_exp_date_'+idx}
                                                            label='Date'
                                                            value={item.date}
                                                            onChange={(date) => this.handleChangeExpenseUncategorized(date, 'date', idx)}
                                                            format={'ddd, MMMM DD YYYY'}
                                                            cancelLabel='BATAL'
                                                            inputVariant='outlined'
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                    {validatorEx.message('date-'+idx, item.date, 'required')}
                                                    <div className='text-danger'>{this.state.errors?.['date-'+idx]}</div>
                                                </div>
                                            </div>
                                            <div className='col-6 col-md-4 col-xl-2'>
                                                <div className='form-group'>
                                                    <TextField
                                                        variant='outlined'
                                                        type='text'
                                                        id={'uncategorized_exp_description-'+idx}
                                                        name={'uncategorized_exp_description-'+idx}
                                                        onChange={(e) => this.handleChangeExpenseUncategorized(e, 'description', idx)}
                                                        label='Description'
                                                        value={item.description ? item.description : ''}
                                                        fullWidth
                                                    />
                                                    {validatorEx.message('description-'+idx, item.description, 'required')}
                                                    <div className='text-danger'>{this.state.errors?.['description-'+idx]}</div>
                                                </div>
                                            </div>
                                            <div className='col-6 col-md-4 col-xl-2'>
                                                <div className='form-group'>
                                                    <TextField
                                                        variant='outlined'
                                                        type='text'
                                                        id={'uncategorized_exp_amount-'+idx}
                                                        name={'uncategorized_exp_amount-'+idx}
                                                        label='Amount'
                                                        value={item.amount ? item.amount : 0}
                                                        onChange={(e) => this.handleChangeExpenseUncategorized(e, 'amount', idx)}
                                                        onBlur={() => this.calculateTotalExpenses()}
                                                        InputProps={{ inputComponent: this.NumberFormatCustom }}
                                                        fullWidth
                                                    />
                                                    {validatorEx.message('amount-'+idx, item.amount, 'required')}
                                                    <div className='text-danger'>{this.state.errors?.['amount-'+idx]}</div>
                                                </div>
                                            </div>
                                            <div className='col-6 col-md-4 col-xl'>
                                                <div className='form-group'>
                                                    <TextField
                                                        variant='outlined'
                                                        type='text'
                                                        id={'uncategorized_exp_remarks-'+idx}
                                                        name={'uncategorized_exp_remarks-'+idx}
                                                        label='Remarks'
                                                        onChange={(e) => this.handleChangeExpenseUncategorized(e, 'remarks', idx)}
                                                        value={item.remarks ? item.remarks : ''}
                                                        fullWidth
                                                    />
                                                    <div className='text-danger'>{this.state.errors?.['remarks-'+idx]}</div>
                                                </div>
                                            </div>

                                        </div>
                                    }.bind(this))
                                    :
                                    <div className='row align-items-center text-center px-4'><div className='col-12'><p>No data available</p></div></div>
                                }
                            </div>

                            <div className='row mx-0 mt-3'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Total Cash Advance</label>
                                        <TextField 
                                            variant='outlined'
                                            type='text'
                                            id='total_in'
                                            name='total_in'
                                            value={this.state.total_in}
                                            InputProps={{ inputComponent: this.NumberFormatCustom }}
                                            disabled
                                            fullWidth
                                        />
                                        {validatorEx.message('total_in', this.state.total_in, 'required')}
                                        <div className='text-danger'>{this.state.errors?.total_in}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mx-0'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Total Survey Expenses</label>
                                        <TextField
                                            variant='outlined'
                                            type='text'
                                            id='total_survey_expenses'
                                            name='total_survey_expenses'
                                            value={this.state.total_survey_expenses}
                                            InputProps={{ inputComponent: this.NumberFormatCustom }}
                                            disabled
                                            fullWidth
                                        />
                                        {validatorEx.message('total_survey_expenses', this.state.total_survey_expenses, 'required')}
                                        <div className='text-danger'>{this.state.errors?.total_survey_expenses}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mx-0'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Total Office Expenses</label>
                                        <TextField
                                            variant='outlined'
                                            type='text'
                                            id='total_office_expenses'
                                            name='total_office_expenses'
                                            value={this.state.total_office_expenses}
                                            InputProps={{ inputComponent: this.NumberFormatCustom }}
                                            disabled
                                            fullWidth
                                        />
                                        {validatorEx.message('total_office_expenses', this.state.total_office_expenses, 'required')}
                                        <div className='text-danger'>{this.state.errors?.total_office_expenses}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mx-0'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Total Expenses</label>
                                        <TextField
                                            variant='outlined'
                                            type='text'
                                            id='total_out'
                                            name='total_out'
                                            value={this.state.total_out}
                                            InputProps={{ inputComponent: this.NumberFormatCustom }}
                                            disabled
                                            fullWidth
                                        />
                                        {validatorEx.message('total_out', this.state.total_out, 'required')}
                                        <div className='text-danger'>{this.state.errors?.total_out}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mx-0'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Saldo</label>
                                        <TextField 
                                            variant='outlined'
                                            type='text'
                                            id='saldo'
                                            name='saldo'
                                            value={this.state.saldo}
                                            InputProps={{ inputComponent: this.NumberFormatCustom }}
                                            disabled
                                            fullWidth
                                        />
                                        {validatorEx.message('saldo', this.state.saldo, 'required')}
                                        <div className='text-danger'>{this.state.errors?.saldo}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mx-0'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Total Survey Hour</label>
                                        <TextField
                                            variant='outlined'
                                            type='text'
                                            id='survey_hours'
                                            name='survey_hours'
                                            onChange={(e) => this.handleChange(e, 'survey_hours')}
                                            value={this.state.survey_hours}
                                            fullWidth
                                        />
                                        {validatorEx.message('survey_hours', this.state.survey_hours, 'required')}
                                        <div className='text-danger'>{this.state.errors?.survey_hours}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mx-0'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label>Total Survey Days</label>
                                        <TextField
                                            variant='outlined'
                                            type='text'
                                            id='survey_days'
                                            name='survey_days'
                                            onChange={(e) => this.handleChange(e, 'survey_days')}
                                            value={this.state.survey_days}
                                            fullWidth
                                        />
                                        {validatorEx.message('survey_days', this.state.survey_days, 'required')}
                                        <div className='text-danger'>{this.state.errors?.survey_days}</div>
                                    </div>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        className='mt-4'
                                        onClick={this.handleSaveExpenses}
                                        disabled={this.state.loadingSave}
                                    >
                                        Save Project Expenses & Rate { this.state.loadingSave && <i className='fa fa-spinner fa-spin'> </i> }
                                    </Button>
                                </div>
                            </div>

                        </div>
                    </div>
                }

                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby='form-dialog-title'>
                    <DialogTitle id='form-dialog-title'>CANCEL PROJECT:</DialogTitle>
                    <DialogContent>
                        <p>Are you sure you wanna cancel this project?</p>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='contained'
                            className='mr-3'
                            onClick={this.handleClose}
                        >
                            No
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            className=''
                            onClick={this.handleCancel}
                            disabled={this.state.loadingButton}
                        >
                            Yes{ this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i> }
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialogRevert}
                    onClose={this.handleCloseRevert}
                    aria-labelledby='form-dialog-title'>
                    <DialogTitle id='form-dialog-title'>REVERT PROJECT:</DialogTitle>
                    <DialogContent>
                        <p>Are you sure you wanna revert this project?</p>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='contained'
                            className='mr-3'
                            onClick={this.handleCloseRevert}
                        >
                            No
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            className=''
                            onClick={this.handleRevert}
                            disabled={this.state.loadingButton}
                        >
                            Yes{ this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i> }
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialogDelete}
                    onClose={this.handleCloseDelete}
                    aria-labelledby='form-dialog-title'>
                    <DialogTitle id='form-dialog-title'>DELETE PROJECT: </DialogTitle>
                    <DialogContent>
                        <p>Are you sure you wanna Delete this project?</p>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='contained'
                            className='mr-3'
                            onClick={this.handleCloseDelete}
                        >
                            No
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            className=''
                            onClick={this.handleDelete}
                            disabled={this.state.loadingButton}
                        >
                            Yes{ this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i> }
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialogDeleteComment}
                    onClose={this.handleCloseComment}
                    aria-labelledby='form-dialog-title'>
                    <DialogTitle id='form-dialog-title'>DELETE COMMENT: {this.state.currDelete}</DialogTitle>
                    <DialogContent>
                        <p>Are you sure you wanna delete this comment?</p>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='contained'
                            className='mr-3'
                            onClick={this.handleCloseComment}
                        >
                            Cancel
                        </Button>
                        {this.state.typeDelete === 'project' &&
                        <Button
                            variant='contained'
                            color='primary'
                            className=''
                            onClick={this.handleDeleteComment}
                            disabled={this.state.loadingButton && 'disabled' }
                        >
                            Delete{ this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i> }
                        </Button>
                        }
                        {this.state.typeDelete === 'client' &&
                        <Button
                            variant='contained'
                            color='primary'
                            className=''
                            onClick={this.handleDeleteCommentClient}
                            disabled={this.state.loadingButton && 'disabled' }
                        >
                            Delete{ this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i> }
                        </Button>
                        }

                    </DialogActions>
                </Dialog>

                <ToastContainer autoClose={3000} />

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        toggle_sidebar_state: state.toggle_sidebar_state,
        profile_state: state.profile_state,
        permission_state: state.permission_state,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(RootActions, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProjectsDetail));
